module.exports = {
	"sv": {
		"moet-core": {
			"select_language": {
				"title": "Välj språk",
				"paragraph": "Det här kommer vara ditt förvalda språk. ",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Alltid inkluderat",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Erbjud alla betalmetoder genom en komplett kassalösning."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Betala nu"
							},
							"description": {
								"default": "Erbjud direktbetalning med kort eller banköverföring."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Betala sen"
							},
							"description": {
								"default": "Erbjud 30 dagar för betalning. Ingen ränta."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Dela upp"
							},
							"description": {
								"default": "Erbjud delbetalning över 6-36 månader.",
								"DE": "Erbjud delbetalning över 6-24 månader",
								"AT": "Erbjud delbetalning över 6-24 månader."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Avbetalningar"
							},
							"description": {
								"default": "Erbjud 3 räntefria avbetalningar.",
								"GB": "Erbjud 3 räntefria avbetalningar."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Avbetalningar",
								"AU": "4 delbetalningar"
							},
							"description": {
								"default": "Erbjud 4 räntefria avbetalningar.",
								"GB": "Erbjud 4 räntefria avbetalningar."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Betalmetoder"
					},
					"description": {
						"default": "Välj från våra fristående betalningslösningar. Använd en eller kombinera flera. Enkel engångsintegration oavsett vad du väljer."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Betala nu"
							},
							"description": {
								"default": "Erbjud direktbetalning med kort eller banköverföring."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Betala sen"
							},
							"description": {
								"default": "Erbjud 30 dagar för betalning. Ingen ränta."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Dela upp"
							},
							"description": {
								"default": "Erbjud delbetalning över 6-36 månader.",
								"DE": "Erbjud delbetalning över 6-24 månader",
								"AT": "Erbjud delbetalning över 6-24 månader."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Avbetalningar"
							},
							"description": {
								"default": "Erbjud 3 räntefria avbetalningar.",
								"GB": "Erbjud 3 räntefria avbetalningar."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 betalningar",
								"CA": "Fyra betalningar",
								"AU": "4 delbetalningar"
							},
							"description": {
								"default": "Erbjud 4 räntefria avbetalningar.",
								"GB": "Erbjud 4 räntefria avbetalningar.",
								"US": "En order på 35–1 000 USD kan delas upp i 4 räntefria betalningar som förfaller varannan vecka.",
								"CA": "Ordrar från 35 $ till 1 000 $ kan delas upp på 4 räntefria betalningar som förfaller varannan vecka."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Byt ut din butiks kassa med Klarnas kompletta kassatjänster."
					},
					"description_expanded": {
						"default": "Byt ut din butiks kassa med Klarnas kompletta kassatjänster."
					}
				},
				"kp_one": {
					"name": {
						"default": "Betalningsmetod"
					},
					"description": {
						"default": "Lägg till Klarna betalningsmetoder i din befintliga kassa"
					},
					"description_expanded": {
						"default": "När du erbjuder Klarnas betalningsmetoder får du en genomsnittlig ökning på 30 % i konverteringar, 41 % i genomsnittligt ordervärde och 36 % i köpfrekvens."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Det här fältet krävs för att fortsätta",
					"generic": "Det värde som angetts är ogiltigt",
					"required_suffix": "krävs för att fortsätta",
					"generic_suffix": "är ogiltigt",
					"min_one": "Du måste välja minst ett element",
					"min": "Du måste välja minst {min} element",
					"max": "Du får inte välja fler än {max} element",
					"given_name": "Förnamn saknas",
					"family_name": {
						"general": "Efternamn saknas",
						"too_short": "Vänligen ange ett giltigt efternamn"
					},
					"date_of_birth": {
						"general": {
							"default": "Ange ett giltigt födelsedatum (DD/MM/ÅÅÅÅ)",
							"US": "Ange ett giltigt födelsedatum (MM/DD/ÅÅÅÅ)"
						},
						"too_young": "Alla intressenter måste vara över 16 år gamla",
						"too_young_eighteen": "Du måste vara över 18 år gammal"
					},
					"street_address": "Vänligen ange en adress",
					"street_address2": "Ange en giltig andra adressrad",
					"postal_code": "Vänligen ange ett postnummer",
					"country": "Vänligen ange ett land",
					"region": "Vänligen ange en region",
					"state": "Vänligen ange en stat",
					"iban": "Vänligen ange ett kontonummer (IBAN)",
					"companyName": "Vänligen ange ett företagsnamn",
					"email": "Vänligen ange en giltig e-postadress",
					"contact_email": "Ange en giltig e-postadress för kontakt",
					"support_email": "Ange en giltig e-postadress för kundsupport",
					"support_phone": "Ange ett giltigt supporttelefonnummer",
					"selling_countries": "Du måste välja minst ett land",
					"store_category": "Du måste välja ett av alternativen",
					"name": "Vänligen ange ett butiksnamn",
					"legal_form": "Vänligen välj en av företagstyperna i listan",
					"generic_toggle_undefined": "Vänligen välj ett av alternativen",
					"website": "Vänligen ange en giltig webbadress",
					"bankAccounts": "Vänligen ange minst ett bankkonto",
					"product": "Vänligen välj en produkt",
					"platform": "Vänligen välj en plattform",
					"password": "Vänligen skapa ett säkert lösenord",
					"currency_code": "Vänligen ange en landskod",
					"account_holder": "Vänligen ange en kontoinnehavare",
					"account_type": "Vänligen ange en kontotyp",
					"routing_number": "Vänligen ange ett giltigt clearingnummer ",
					"account_number": {
						"first": "Vänligen ange ett gilitigt kontonummer för standardkontot",
						"second": "Vänligen ange ett gilitigt kontonummer för det första extrakontot",
						"third": "Vänligen ange ett gilitigt kontonummer för det andra extrakontot",
						"fourth": "Vänligen ange ett gilitigt kontonummer för det tredje extrakontot",
						"general": "Vänligen ange ett gilitigt kontonummer"
					},
					"role": "Vänligen ange en roll",
					"address": "Vänligen ange en adress",
					"political_exposed_person": "Vänligen ange information kring person i politiskt utsatt ställning (PEP)",
					"pep_position": "Vänligen ange information kring position",
					"pep_relationship": "Vänligen ange information kring förhållande till person i politiskt utsatt ställning",
					"goodsCategory": "Vänligen ange en varukategori",
					"registered": "Vänligen ange information kring din företagsregistrering",
					"subjectToVat": "Vänligen ange ett momsregistreringsnummer",
					"registrationCourt": "Vänligen ange en registreringsdomstol",
					"registrationId": {
						"general": {
							"default": "Ange ett giltigt registreringsnummer",
							"AT": "Ange ett giltigt registreringsnummer",
							"AU": "Ange ett giltigt ACN",
							"ES": "Ange ett giltigt NIF/NIE/DNI för företaget",
							"GB": "Ange ett giltigt organisationsnummer",
							"GR": "Ange ett giltigt G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"CA": "Ange ett giltigt företagsnummer",
							"NZ": "Vänligen ange ett giltigt företagsnummer",
							"US": "Ange ett gilitigt arbetsgivarnummer"
						},
						"missing_leading_0_GB": "Vänligen ange ett 8-siffrigt organisationsnummer. Ditt organisationsnummer kan sakna siffran 0 i början (t. ex. 03452678)",
						"invalid": {
							"default": "Ange ett giltigt registreringsnummer",
							"AT": "Registreringsnummer ska vara 5 till 11 tecken långt. Vänligen notera att detta inte är ditt momsregistreringsnummer eller Merchant ID.",
							"AU": "ACN-numret ska vara 9 siffror långt utan blanksteg. Exempel: 123456789",
							"BE": "Registreringsnummer ska vara 10 siffror långt, t.ex. 1234567890",
							"CA": "Företagsnummer ska vara 9 siffror långt, t.ex. 123456789",
							"CZ": "Registreringsnummer ska vara 8 siffror långt, t. ex. 12345678",
							"DE": "Registreringsnummer ska vara 6 till 11 tecken långt och måste börja med HRA, HRB, GnR, VR eller PR följt av ett blanksteg. Vänligen notera att detta inte är ditt momsregistreringsnummer eller Merchant ID.",
							"ES": "NIF/NIE/DNI ska vara 8 eller 9 tecken långt och börja med 1 bokstav/siffra följt av 6 eller 7 siffror och 1 bokstav/siffra",
							"FI": "Registreringsnummer ska vara 8 siffror långt med ett bindestreck före sista siffran och utan blanksteg, t. ex. 1234567-8",
							"FR": "Registreringsnummer ska vara 9 siffror långt, t. ex. 123 456 789 eller 123456789 (SIREN), alternativt 14 siffror långt, t. ex. 123 456 789 12345 eller 12345678912345 (SIRET).",
							"IE": "Registreringsnumret ska vara två bokstäver följt av sex siffror eller endast sex siffror om du är enskild näringsidkare (t.ex. AB123456).",
							"IT": "Registreringsnummer ska vara 11 siffror långt (t.ex. 01234567890) eller en kombination av 16 siffror och stora bokstäver (t.ex. ABCABC12A12A123A)",
							"GB": "Organisationsnumret ska vara 8 siffror långt. T.ex.: 12345678, eller två bokstäver följt av 6 siffror (SC123456), eller 1 bokstav följt av 7 siffror (S1234567)",
							"GR": "G.E.MI.-nummer ska vara 12 siffror långa, t.ex. 012345678901",
							"NL": "Registreringsnummer ska vara 8 siffror långt, t. ex. 12345678",
							"NO": "Registreringsnummer ska vara 9 siffror långa och utan mellanslag, t. ex. 123456789",
							"NZ": "Företagsnummer ska vara 13 siffror långt, t.ex. 1234567890123",
							"PL": "Registreringsnummer ska vara 10 siffror långt utan blanksteg, t. ex. 1234561234",
							"PT": "Registreringsnumret ska vara 9 siffror långt utan blanksteg. Exempel: 123123123",
							"SE": "Registreringsnummer ska vara 10 siffror långt med ett bindestreck och utan blanksteg, t. ex. 123456-1234",
							"US": "Arbetsgivarnummer ska vara 9 siffror långt med ett \"-\" efter de första två, t. ex. 12-3456789",
							"MX": "RFC ska vara 12 tecken långt, börja med företagets initialer, det sexsiffriga bolagsdatumet och checkens värde. T.ex.: ABC921010H20"
						}
					},
					"tocLink": "Något gick fel med villkoren. Vänligen försök igen senare eller kontakta vår kundtjänst på {supportEmail}",
					"vat": {
						"general": {
							"default": "Ange ett giltigt momsregistreringsnummer",
							"AU": "Ange ett giltigt australiskt organisationsnummer",
							"ES": "Ange ett giltigt NIF/NIE/DNI för företaget",
							"NZ": "Ange ett giltigt GST-nummer"
						},
						"invalid": {
							"default": "Ogiltigt momsregistreringsnummer",
							"AT": "Momsregistreringsnummer ska vara ATU följt av 8 siffror, t. ex. ATU12345678",
							"AU": "Australiskt organisationsnummer ska vara 11 siffror långt.",
							"CZ": "Momsregistreringsnummer ska vara CZ följt av 8, 9 eller 10 siffror. T.ex.: CZ123456789",
							"GR": "Momsnummer ska vara nio siffror långt och måste börja med EL. Eg: EL123456789",
							"DE": "Momsregistreringsnummer ska vara DE följt av 9 siffror, t. ex. DE123456789",
							"ES": "NIF/NIE/DNI ska vara 8 eller 9 tecken långt och börja med 1 bokstav/siffra följt av 6 eller 7 siffror och 1 bokstav/siffra",
							"FR": "Momsnummer ska vara SE följt av 2 bokstäver/siffror och 9 siffror (SIREN), t. ex. SEXX123456789",
							"GB": "Momsregisteringsnummer ska vara mellan 6 och 15 tecken långt.",
							"IE": "Momsnumret ska vara IE följt av 8 eller 9 tecken som innehåller 1 eller 2 bokstäver. T.ex.: IE1234567WA, IE1234567A",
							"IT": "Momsregistreringsnummer ska vara IT följt av 11 siffror, t. ex. IT12345678912",
							"NL": "Momsregistreringsnummer ska vara NL följt av 9 siffror, följt av B och 2 siffror, t. ex. NL123456789B12",
							"NZ": "GST-nummer ska vara 8 siffror långt (12345678) eller 9 siffror långt, med eller utan ett bindestreck var 3:dje siffra (123-123-123 eller 123123123)",
							"PL": "Momsregistreringsnummer ska vara PL följt av 10 siffror, t. ex. PL1234567890",
							"PT": "Momsnummer ska vara PT följt av 9 siffror. Exempel: PT123123123",
							"MX": "RFC ska börja med företagets initialer, det sexsiffriga bolagsdatumet och checkens värde. T.ex.: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Vänligen ange de 4 sista siffrorna i ditt SSN",
							"format": "Vänligen ange de 4 sista siffrorna i ditt SSN"
						},
						"US_FULL_SSN": {
							"general": "Ange hela (9 siffror) SSN",
							"format": "Ange hela (9 siffror) ditt SSN"
						},
						"CA": {
							"general": "Vänligen ange ett giltigt SIN eller ett passnummer",
							"format": "SIN: XXX-XXX-XXX / Passnummer: ABXXXXXX"
						},
						"SE": {
							"general": "Ange ett giltigt personnummer (PNO)",
							"format": "Vänligen ange PNO enligt formatet ÅÅÅÅMMDD-XXXX"
						},
						"FI": {
							"general": "Ange en giltig personkod (HETU)",
							"format": "Vänligen ange HETU enligt formatet DDMMÅÅSXXXX"
						},
						"NO": {
							"general": "Ange ett giltigt nationellt ID-nummer",
							"format": "Vänligen ange enligt formatet DDMMÅÅXXXXX"
						},
						"DK": {
							"general": "Ange ett giltigt personnummer (CPR)",
							"format": "Vänligen ange CPR enligt formatet DDMMÅÅ-XXXX"
						},
						"IT": {
							"general": "Vänligen ange en giltig skattekod",
							"format": "Vänligen ange skattekod enligt formatet CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Vänligen ange ett giltigt personnummer (DNI eller NIE)",
							"format": "Vänligen ange DNI eller NIE, t.ex. 12345678A"
						},
						"PL": {
							"general": "Ange en giltig personlig identifieringskod (PESEL)",
							"format": "Ange PESEL i formatet: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Vänligen ange ett giltigt passnummer"
						}
					},
					"store_name": "Vänligen ange ett butiksnamn"
				},
				"errors_keys": {
					"correlationIdLabel": "Korrelations-ID: {correlationId}",
					"decisionTaken": "Förhandsbeslut har redan fattats. Vänligen ladda om sidan.",
					"maintenanceMode": "Vår app är för närvarande nere för underhåll. Vänligen kom tillbaka senare",
					"validation": {
						"storeName": {
							"invalidType": "Vänligen ange ett giltigt butiksnamn."
						},
						"email": {
							"invalidType": "Vänligen ange en giltig e-postadress."
						},
						"goodsCategory": {
							"invalidType": "Vänligen ange en varukategori."
						},
						"website": {
							"invalidType": "Vänligen ange en giltig webbsida."
						}
					}
				}
			},
			"general": {
				"yes": "Ja",
				"no": "Nej",
				"encrypted_text": "*******",
				"pricing_link_eu": "Se alla priser per land",
				"pricing_link_us": "Se priser",
				"formFieldOptional": "valfritt",
				"buttons": {
					"next": "Nästa",
					"back": "Tillbaka",
					"continue": "Fortsätt",
					"submit_application": {
						"default": "Kom igång",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Kom igång"
					},
					"add_aditional_item": "+ Lägg till ytterligare artikel"
				},
				"unknown_step_title": "Ange den information som behövs",
				"selected": "Vald",
				"clear_all": "Rensa alla"
			},
			"errors": {
				"general": "Ett fel uppstod. Vänligen kontakta vår support.",
				"salesforce": "Försök att uppdatera sidan. Om felet kvarstår, skicka fel-ID till slack-kanalen #smooothforce-support så hjälper vi dig.",
				"managed_kyc": "Försök att uppdatera sidan. Om felet kvarstår, kontakta vår kundservice för handlare eller din säljkontakt.",
				"copy": "Kopiera",
				"noTermsAccepted": "Vänligen läs och godkänn alla våra avtalsdokument",
				"termsAlreadyAccepted": "Du har redan godkänt samtliga avtal",
				"mandatoryField": " är obligatorisk"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Enskild näringsidkare",
					"PARTNERSHIP": "Partnerskap",
					"PUBLIC_LISTED_COMPANY": "Börsnoterat företag",
					"PRIVATE_COMPANY": "Privat företag"
				},
				"organization_entity_types": {
					"C_CORP": "C-corporation",
					"S_CORP": "S-corporation",
					"PARTNERSHIP": "Partnerskap",
					"TRUST_ESTATE": "Stiftelse/dödsbo",
					"INDIVIDUAL": "Individ",
					"SOLE_PROPRIETORSHIP": "Ensam äganderätt",
					"SOLE_TRADER": "Enskild näringsidkare",
					"LIMITED_LIABILITY_COMPANY": "LLC (Limited Liability Company)",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "LLC med en medlem"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor för vuxna",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Fordonsprodukter - Fordonsdelar och tillbehör",
					"BAGS_AND_WALLETS": "Smycken & Accessoarer - Väskor och plånböcker",
					"BODY_AND_HAIR_CARE": "Hälsa & Skönhet - Kropps- och hårvård",
					"BOOK_AND_MAGAZINES": "Underhållning - Böcker och tidningar",
					"CANDY": "Mat & Dryck - Godis",
					"CAR_ELECTRONICS": "Elektronik - Bilelektronik",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Barnprodukter - Barnkläder och vårdprodukter",
					"CHILDREN_TOYS": "Barnprodukter - Barnleksaker",
					"CLEANING_AND_SANITARY": "Hem & Trädgård - Rengörings- och sanitetsprodukter",
					"COLLECTIBLES": "Fritid, Sport & Hobby - Samlarobjekt",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Fritid, Sport & Hobby - Konceptbutiker och diverse",
					"COSMETICS": "Hälsa & Skönhet - Kosmetika",
					"COSTUMES_AND_PARTY_SUPPLIES": "Fritid, Sport & Hobby - Kostymer och festtillbehör",
					"DATING_SERVICES": "Immateriella produkter - Dejtingtjänster",
					"DECORATION_AND_ART": "Hem & Trädgård - Dekoration och konst",
					"DIETARY_SUPPLEMENTS": "Hälsa & Skönhet - Kosttillskott",
					"DIGITAL_SERVICES": "Immateriella produkter - Digitala tjänster",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Barnprodukter - Diversifierade barnprodukter",
					"DIVERSIFIED_ELECTRONICS": "Elektronik - Diversifierad elektronik",
					"DIVERSIFIED_ENTERTAINMENT": "Underhållning - Diversifierad underhållning",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotiskt material - Diversifierad erotik",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Hälsa och skönhet – diversifierade hälso- och skönhetsprodukter",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hem & Trädgård - Diversifierade hem- och trädgårdsprodukter",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Smycken & Accessoarer - Diversifierad smycken och accessoarer",
					"EDUCATION": "Immateriella produkter - Utbildning",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronik - Elektronisk utrustning och relaterade tillbehör",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotiskt material - Erotiska kläder och tillbehör",
					"EVENT_TICKETS": "Immateriella produkter - Eventbiljetter",
					"FOOD_AND_BEVERAGE": "Mat & Dryck - Mat och dryck",
					"FRAGRANCES": "Hälsa & Skönhet - Parfymer",
					"FURNITURE": "Hem & Trädgård - Möbler",
					"GENERAL_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor",
					"HOBBY_ARTICLES": "Fritid, Sport & Hobby - Hobbyartiklar",
					"HOUSEHOLD_ELECTRONICS": "Elektronik - Hushållselektronik",
					"JEWELRY_AND_WATCHES": "Smycken & Accessoarer - Smycken och klockor",
					"KITCHENWARE": "Hem & Trädgård - Köksutrustning",
					"MARKETPLACES": "Immateriella produkter - Marknadsplatser",
					"MUSIC_AND_MOVIES": "Underhållning - Musik och film",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Fritid, Sport & Hobby - Musikinstrument och tillbehör",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Smycken & Accessoarer - Receptfria solglasögon och linser",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronik - Kontorsmaskiner och relaterade tillbehör",
					"OTHER_SERVICES": "Immateriella produkter - Andra tjänster",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Hälsa & Skönhet - Personlig omvårdnad och kroppsförbättring",
					"PET_SUPPLIES": "Hem & Trädgård - Djurtillbehör",
					"PHARMACEUTICAL_PRODUCTS": "Hälsa & Skönhet - Farmaceutiska produkter",
					"PLANTS_AND_FLOWERS": "Hem & Trädgård - Plantor och blommor",
					"PRESCRIPTION_OPTICS": "Hälsa & Skönhet - Receptbelagd optik",
					"PRINTS_AND_PHOTOS": "Fritid, Sport & Hobby - Tryck och foton",
					"SAFETY_PRODUCTS": "Hem & Trädgård - Säkerhetsprodukter",
					"SEX_TOYS": "Erotiskt material - Sexleksaker",
					"SPORTS_GEAR_AND_OUTDOOR": "Fritid, Sport & Hobby - Sport- och fritidsutrustning",
					"TOBACCO": "Mat & Dryck - Tobak",
					"TOOLS_AND_HOME_IMPROVEMENT": "Hem & Trädgård - Verktyg och renovering",
					"TRAVEL_SERVICES": "Immateriella produkter - Resetjänster",
					"UNDERWEAR": "Kläder & Skor - Underkläder",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Underhållning - TV-spel och relaterade tillbehör",
					"WHEELS_AND_TIRES": "Fordonsprodukter - Hjul och däck",
					"WINE_BEER_AND_LIQUOR": "Mat & Dryck - Vin, öl och sprit",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor för unga",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Åldersbegränsad — spel, betting, casino och lotteri",
					"CHARITIES_AND_NGO": "Immateriella produkter — välgörenhet och NGO-tjänster",
					"EROTIC_SERVICES": "Erotiskt material — erotiska tjänster",
					"FINANCIAL_SERVICES_CRYPTO": "Finansiella tjänster — kryptorelaterade aktiviteter",
					"FINANCIAL_SERVICES_MSB": "Finansiella tjänster — pengatjänster",
					"FINANCIAL_SERVICES_E_WALLETS": "Finansiella tjänster — e-plånböcker",
					"FINANCIAL_SERVICES_TRADING": "Finansiella tjänster — handel",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Immateriella produkter — communities på sociala plattformar",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Resa – Flygrese- och kryssningsoperatörer",
					"TRAVEL_BROKER_AND_AGENCIES": "Resor – Resebyråer",
					"TRAVEL_GROUND_TRANSPORTATION": "Resa – Marktransport",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Resor - Boende och resorter",
					"EVENT_ORGANIZER": "Evenemang – Arrangör",
					"EVENT_BROKER_AND_AGENCIES": "Evenemang – Arrangörer"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Kalifornien",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawaii",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "North Carolina",
					"ND": "North Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "South Carolina",
					"SD": "South Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Person",
						"COMPANY": "Företagare"
					},
					"roles": {
						"OWNER": "Ägare",
						"ULTIMATE_BENEFICIAL_OWNER": "Verklig huvudman",
						"CONTROL_OVER_MANAGEMENT": "Kontroll över ledningsgrupp",
						"APPLICANT": "Behörig firmatecknare",
						"SOLE_TRADER": "Enskild näringsidkare",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Dagligen",
					"WEEKLY": "Veckovis"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Traditionell försäljning av varor",
						"description": "Handlaren säljer produkter eller tjänster på ett traditionellt sätt. Varorna anses vara konsumerade när de levereras och det är vanligtvis ingen längre tid mellan order och leverans"
					},
					"VOUCHER": {
						"label": "Kupong",
						"description": "Mer än 10 % av försäljningen består av kuponger och/eller presentkort"
					},
					"MEMBERSHIP": {
						"label": "Medlemskap",
						"description": "Mer än 10 % av försäljningen består av medlemskap"
					},
					"SUBSCRIPTION": {
						"label": "Abonnemang",
						"description": "Mer än 10 % av försäljningen består av prenumerationer"
					},
					"PHARMACIES": {
						"label": "Apotek",
						"description": "Handlare säljer receptbelagda eller icke receptbelagda läkemedel"
					},
					"US_PHARMACIES": {
						"label": "Amerikanska apotek",
						"description": "Handlaren säljer receptbelagda eller icke-receptbelagda läkemedel i USA"
					},
					"MEDICAL_SERVICES": {
						"label": "Medicinska tjänster",
						"description": "Handlaren säljer medicinska tjänster, såsom tester, undersökningar eller omvårdnad"
					},
					"MARKETPLACES": {
						"label": "Marknadsplatser",
						"description": "Handlare har en relation som underhandlare"
					},
					"FIREARM_DEALERS": {
						"label": "Vapenhandlare",
						"description": "Handlare säljer vapen eller ammunition som kräver licens"
					},
					"AUCTIONS": {
						"label": "Auktioner",
						"description": "Handlare är ett auktionshus"
					},
					"ALCOHOL": {
						"label": "Alkohol",
						"description": "Handlare säljer alkohol"
					},
					"TOBACCO": {
						"label": "Tobak",
						"description": "Handlare säljer tobak med eller utan nikotin eller e-cigaretter"
					},
					"HEMP_CBD_THC": {
						"label": "Hampa, CBD eller THC",
						"description": "Handlare säljer produkter som innehåller hampa, CBD eller THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donationer och välgörenhet",
						"description": "Handlare är en organisation som arbetar med donationer eller välgörenhet som använder \"utbetalning efter uppgörelse\""
					},
					"TRAVEL": {
						"label": "Resor",
						"description": "Mer än 10 % av försäljningen består av resor"
					},
					"EVENTS": {
						"label": "Evenemang",
						"description": "Mer än 10 % av försäljningen består av evenemang"
					},
					"COURSES": {
						"label": "Kurser",
						"description": "Mer än 10 % av försäljningen består av kurser"
					},
					"EDUCATIONAL_COURSES": {
						"label": "",
						"description": ""
					},
					"FOOD_DELIVERY": {
						"label": "",
						"description": ""
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "",
						"description": ""
					},
					"DIGITAL_CONTENT": {
						"label": "",
						"description": ""
					},
					"GAMING_INDUSTRY": {
						"label": "",
						"description": ""
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hej {firstName}",
						"primary_title_without_name": "Hej,",
						"sub_title": "Mer Klarna är mer Klarna som Shakespeare en gång sa.",
						"sub_title_no_products": "Starta din Klarnaupplevelse genom att välja en produkt nedan",
						"sub_title_kp_products": "Välj en till Klarnaprodukt",
						"sub_title_ongoing_product": "Fortsätt konfigurationen av {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Betalprodukter",
							"text_blocks": [
								{
									"text": "Lägg till en lösning till din konfiguration"
								}
							]
						}
					},
					"buttons": {
						"start": "Starta",
						"continue": "Fortsätt",
						"view_summary": "Visa sammanfattning",
						"add_another_product": "Lägg till en produkt"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Byt till vår Playground-miljö för att utforska mer samt generera test API-nycklar så du kan prova din plattform.",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Marknadsföringsresurser",
							"text": "Genom att använda Klarna ger du kunder en smoooth köpupplevelse. Utnyttja våra marknadsföringsresurser för att få dem exhalterade kring nyheten.",
							"link": "Hämta resurser"
						},
						"your_application": {
							"title": "Din ansökan",
							"text": "Klicka här för att färdigställa din konfiguration eller för att se dina ansökningsdetaljer inklusive villkor.",
							"link": "Öppna"
						},
						"invite_more_users": {
							"title": "Bjud in fler användare",
							"text": "Bjud in dina samarbetspartners till Butiksportalen. Du kan ställa in anpassade behörigheter för varje person.",
							"link": "Bjud in användare"
						}
					},
					"footer": {
						"title": "Alltid inkluderat med Klarna",
						"list": {
							"merchant_portal": {
								"title": "Butiksportalen",
								"text_blocks": [
									{
										"text": "Hantera allt relaterat till Klarna med full åtkomst till backend."
									}
								]
							},
							"global_products": {
								"title": "Globala produkter, lokala utföranden",
								"text_blocks": [
									{
										"text": "Alla våra produkter är designade att möta lokala preferenser och lagstiftning."
									}
								]
							},
							"local_support": {
								"title": "Lokal support för dig och dina kunder",
								"text_blocks": [
									{
										"text": "Vi har tusentals personer som är redo att hjälpa dina kunder när de behöver assistans."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna som marknadsföringsverktyg",
								"text_blocks": [
									{
										"text": "Vi ger dig åtkomst till material från Klarna som du kan använda i din marknadsföring."
									}
								]
							},
							"single_integration": {
								"title": "Engångsintegration, automatiska uppdateringar",
								"text_blocks": [
									{
										"text": "En integration, inga uppdateringar. Någonsin."
									},
									{
										"text": "När du integrerat med Klarna behöver du inte lyfta ett finger igen tack vare automatiska uppdateringar."
									}
								]
							},
							"no_risk": {
								"title": "Riskfritt för dig och dina kunder",
								"text_blocks": [
									{
										"text": "Dina utbetalningar är alltid garanterade medan dina kunder täcks av Klarnas Köparskydd."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarna API-nycklar",
							"text_blocks": [
								{
									"text": "Klarna API-nycklar ansluter vår produkt till din butik så att du kan börja sälja."
								}
							]
						},
						"toc_key": {
							"title": "Villkor",
							"text_blocks": [
								{
									"text": "Du behöver uppdatera dina villkor för e-handel"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Integrationsinstruktioner",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Hur man använder Klarna API-nycklar",
							"ordered_list": {
								"one": "Generera och ladda ner dina nycklar",
								"two": "Klistra in nycklarna (Klarna API-användarnamn och -lösenord) i din plattform så som beskrivs i integrationsinstruktionerna nedan"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "5 Klarna API-nycklar totalt",
							"text": "Du kan generera upp till fem Klarna API-nycklar. Få den första här och skapa resten under Inställningar.",
							"button": "Generera Klarna API-nycklar"
						},
						"how_to_update_toc": {
							"title": "Hur man uppdaterar villkor",
							"ordered_list": {
								"one": "Besök länken",
								"two": "Läs instruktionerna och kopiera texten",
								"three": "Inkludera den i villkoren för din butik"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Kom ihåg att uppdatera texten med produkterna du anmält dig till.",
							"linkText": "Gå till uppdaterade villkor >"
						},
						"buttons": {
							"back": "Tillbaka"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Din ansökan granskas...",
						"TRANSACTION_DETAILS_STARTED": "Din ansökan granskas av vårt team. Vi återkommer så snart som möjligt.",
						"TRANSACTIONS_REVIEW_MANUAL": "Din ansökan granskas av vårt team. Vi återkommer så snart som möjligt.",
						"TRANSACTIONS_ENABLED": "Grattis! Du är redo att sälja med Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Din utbetalningsförfrågan granskas...",
						"PAYOUTS_REVIEW_MANUAL": "Din utbetalningsförfrågan granskas av vårt team. Vi återkommer så snart som möjligt.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Väntar på din första försäljning med Klarna...",
						"TRANSACTIONS_DISABLED": "Ditt konto är avaktiverat tills du slutfört aktivering av utbetalningssteget.",
						"SUSPENDED": "Ditt konto är avstängt.",
						"notice": "För tillfället har vi längre hanteringstider än vanligt. Men var inte orolig, din ansökan är under granskning och vi kommer att höra av oss med mer information så snart vi kan. Tack för din förståelse och ditt tålamod!"
					},
					"statuses": {
						"pending": "Väntande",
						"done": "Klar"
					},
					"in_review": {
						"title": "Vi håller på att granska din ansökan.",
						"subtitle": "Vi gör en sista granskning av din ansökan för att säkerställa att allt i kontraktet ser bra ut. Detta är en manuell process, vilket betyder att behandlingsstiderna kan variera och att vi gör det så snart som möjligt.",
						"content": {
							"title": "Se till att följande information finns synlig på din webbsida för att granskningen ska gå så snabbt som möjligt:",
							"list": {
								"default": {
									"item_1": "Ditt registrerade företagsnamn",
									"item_2": "Ditt registrerade företagsnamn",
									"item_3": "Din registrerade företagsadress",
									"item_4": "Returpolicy på minst 14 dagar",
									"item_5": "E-post eller telefonnummer till kundservice"
								},
								"US": {
									"item_1": "Registrerat företagsnamn",
									"item_2": "Returpolicy",
									"irem_3": "E-post eller telefonnummer till kundservice"
								},
								"AU": {
									"item_1": "ABN (företagsnummer) eller registrerat företagsnamn.",
									"item_3": "Din registrerade företagsadress",
									"item_4": "Returpolicy på minst 14 dagar",
									"item_5": "E-post eller telefonnummer till kundservice"
								}
							}
						},
						"footer": "Vi skickar dig ett e-postmeddelande när granskningen är klar eller om vi behöver någon ytterligare information från dig."
					},
					"suspended": {
						"title": "Tyvärr...",
						"subtitle": "Efter att ha granskat dina avtalsuppgifter var vi tvungna att avslå din ansökan. Det kan finnas flera anledningar till att din ansökan inte godkändes. Nedan är några av de vanligaste faktorerna:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Din butik följer inte Klarnas etiska riktlinjer.",
								"item_2": "Kontaktpersonen i din ansökan kan inte nås.",
								"item_3": "Andra tekniska eller administrativa faktorer."
							}
						},
						"footer": "Tack för ditt intresse i Klarna. Vänligen kontakta oss om du har några frågor eller vill registrera en annan butik i framtiden."
					},
					"disabled": {
						"title": "Din ansökan har inaktiverats.",
						"subtitle": "Ditt konto inaktiverades då det saknar obligatorisk, juridisk information.",
						"content": {
							"title": "Detta sker vanligtvis då Klarna har bett dig att ange någon information och du inte svarade före angiven deadline."
						},
						"footer": "Kontakta Butikssupport med uppgifterna i sidfoten på den här sidan om du tror att detta har skett av misstag eller vill skicka in informationen på nytt.."
					},
					"ready_to_connect": {
						"title": "Anslut din butik",
						"subtitle": "Ditt kontrakt är klart. Du kan nu integrera Klarna i din butik. Följ stegen nedan för att slutföra integrationen.",
						"status_messsage": {
							"title": "Integration ej slutförd ännu",
							"subtitle": "Följ integrationsinstruktionerna för att ansluta din butik. Statusen ändras till grön när en transaktion med Klarna har gjorts."
						},
						"content": {
							"title": "Instruktioner",
							"options": {
								"label_1": "Generera och spara dina Klarna API-nycklar",
								"description_1": "Generera nya API-nycklar och ladda ner dem på din dator. Du behöver dessa API-nycklar i nästa sektion.",
								"label_2": "Installera Klarna på din Shopifybutik"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Nästan där",
						"subtitle": "Du är ett steg närmare att kunna erbjuda dina kunder en smoooth shoppingupplevelse! Ditt avtal har slutförts och din butik är redo att integreras.",
						"buttons": {
							"connect": "Anslut din butik"
						},
						"additional_info": "Observera att integrationen kommer bara att markeras som helt genomförd när vi mottar det första köpet, vilket också kan ta ett tag beroende på din plattform."
					},
					"store_connected": {
						"title": "Din butik är ansluten",
						"subtitle": "Din butiksintegration är slutförd. Dina kunder kan nu betala med Klarna.",
						"status_messsage": {
							"title": "Integration lyckades",
							"subtitle": "En Klarnatransaktion har behandlats i din butik.",
							"button_text": {
								"shown": "Visa integrationsinstruktioner",
								"hidden": "Göm integrationsinstruktioner"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Din ansökan",
							"subtitle": "Granska information i din ansökan.",
							"button_text": "Visa sammanfattning"
						},
						"connect_store": {
							"title": "Klarna API-nycklar",
							"subtitle": "Generera dina Klarna API-nycklar för att integrera din butik",
							"button_text": "Generera Klarna API-nycklar"
						},
						"add_product": {
							"title": "Produkter",
							"subtitle": "Klicka här om du vill lägga till en produkt för den här konfigurationen.",
							"button_text": "Lägg till produkter"
						}
					},
					"timeline": {
						"application": {
							"title": "Din ansökan",
							"alert": {
								"view_summary": "Visa sammanfattning",
								"rejected": "Vi var tvungna att avslå din ansökan.",
								"review": "Granska din ansökningsinformation genom att klicka på länken nedan."
							}
						},
						"payouts": {
							"title": "Utbetalningar aktiverade"
						},
						"integration": {
							"title": "Integration ej slutförd ännu",
							"alert": "Följ integreringsinstruktionerna för att ansluta din butik."
						},
						"integration_complete": {
							"title": "Integrationen är klar!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Grattis! Din konfigurering är klar.",
						"rejection": "Tyvärr, vi kunde inte slutföra din konfigurering."
					},
					"header_new": {
						"title": "Välkommen Klarna Handlare! ",
						"subtitle": "Sammanfattning ",
						"rejection": "Ansökan avslagen"
					},
					"joy_section": {
						"approved": {
							"title": "Godkänd!",
							"content": "Din ansökan har granskats och godkänts. Du har nu full åtkomst till Klarnas tjänster. Vi ser fram emot att jobba tillsammans med dig! ",
							"button_title": "Kolla dina beställningar",
							"link": "eller våra marknadsföringsresurser"
						},
						"rejected": {
							"title": "Tyvärr...",
							"content_1": "Efter att ha granskat din ansökan kan vi inte godkänna ditt handlarkontrakt.",
							"content_2": "Du är välkommen att kontakta vår support om du har några frågor"
						}
					},
					"sidebar_left": {
						"application_details": "Dina ansökningsuppgifter",
						"store_details": {
							"title": "Butiksuppgifter",
							"text_blocks": [
								{
									"text": "En sammanfattning av dina uppgifter"
								}
							]
						},
						"credentials": {
							"title": "Klarna API-nycklar",
							"text_blocks": [
								{
									"text": "Dina Klarna API-nycklar"
								}
							]
						},
						"payouts": {
							"title": "Utbetalningar",
							"text_blocks": [
								{
									"text": "Dina inlämnade bankuppgifter"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Ytterligare bankkonton",
							"text_block": null
						},
						"business_owners": {
							"title": "Företagsägare",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Personer med väsentligt inflytande",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Intressenter",
							"text_blocks": [
								{
									"text": "Din inlämnade information"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Företagsägare",
								"no_elements": "Du angav ingen företagsägare"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Standardkonto",
								"no_elements": "Inget standardkonto tillgängligt"
							},
							"additional_bank_accounts": {
								"title": "Ytterligare bankkonton",
								"no_elements": "Du angav inga ytterligare bankkonton"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Ägare",
								"no_elements": "Du angav inga ägare"
							},
							"ultimate_beneficial_owner": {
								"title": "Huvudman",
								"no_elements": "Du angav inga huvudmän"
							},
							"applicant": {
								"title": "Sökanden",
								"no_elements": "Du angav ingen sökande"
							},
							"control_over_management": {
								"title": "Person med kontroll över ledningsgrupp",
								"no_elements": "Du angav inga intressenter med kontroll över ledningsgruppen"
							}
						},
						"buttons": {
							"back": "Tillbaka",
							"next_step": "Nästa"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Vi har redan dina uppgifter",
							"text_blocks": [
								{
									"text": "Detta är informationen du gett oss vid tidigare tillfälle."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Du angav ingen företagsägare"
						},
						"buttons": {
							"submit": "Skicka",
							"back": "Tillbaka"
						}
					}
				},
				"checking_page": {
					"title": "Kontrollerar...",
					"subtitle": "Tack för att du skickade in ansökan. Vänligen vänta medan vi kontrollerar den..."
				},
				"success_page": {
					"title": "Du kan nu ansluta din butik",
					"subtitle": "Tack för att du skickade in ansökan.",
					"buttons": {
						"next": "Nästa"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Grunder",
						"business": "Företag",
						"stakeholders": "Intressenter",
						"bank_accounts": "Bankkonton"
					}
				},
				"app_error": {
					"title": "Appen Products är inte tillgänglig för tillfället",
					"message": "Vi har problem med vår app och jobbar redan på att fixa detta. Vi försöker lösa alla problem så snart som möjligt. Vänligen försök igen senare."
				},
				"temporarily_down": {
					"title": "Vi har tekniska problem för tillfället",
					"message": "Vi ber om ursäkt för eventuella olägenheter och försäkrar dig om att vi gör vårt bästa för att lösa problemet. Vänligen kom tillbaka igen senare."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Vår Products App är för närvarande nere för underhåll",
						"signup_app": "Vår Registeringsapp är för närvarande nere för underhåll"
					},
					"message": "Vi arbetar för att förbättra din upplevelse och hoppas vara klara så snart som möjligt. Vänligen kom tillbaka igen senare."
				},
				"unknown_merchant": {
					"before_link": "Om du redan har ett avtal med oss, vänligen besök",
					"link_text": "den här sidan",
					"after_link": "för att lära dig mer om våra produkter"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Ett fel uppstod.",
						"invalid_token": "Den här länken har gått ut"
					},
					"message": {
						"invalid_token_risk": "Kontakta oss via slack-kanalen #smooothforce-support så hjälper vi dig.",
						"invalid_token": "Kontakta din säljkontakt.",
						"invalid_flow_type": "Handlarens onboarding-typ och status är inkompatibla. Om du tror att ett fel har uppstått, vänligen hör av dig till Kundservice för handlare."
					}
				},
				"topbar": {
					"title": "Konfiguration",
					"widget_type": {
						"MANAGED_KYC": "Insamling för kundkännedom",
						"MANAGED_RISK": "Insamling för förhandsbedömning",
						"MANAGED_SME_RISK": "Insamling för förhandsbedömning små och medelstora företag"
					}
				},
				"product_card": {
					"incompatible_description": "Inte tillgängligt för ditt land/din plattform",
					"kco_footer_text": "Vilka betalmetoder som finns tillgängliga i Klarna Checkout beror på vilket land du är registrerad i och landet du säljer till.",
					"products_link_text": "Mer"
				},
				"product_prices_card": {
					"title": "Produkter",
					"subtitle": "{country}",
					"pricing": "Priser för {country}",
					"monthly_fee": "månadsavgift",
					"transaction_fee": "transaktionsavgift",
					"before_link": "Jag godkänner Klarnas",
					"link_text": "Villkoren",
					"after_link_one_product": "för denna produkt",
					"after_link_more_than_one_product": "för dessa produkter",
					"product_not_available_in_your_country": "* Den här produkten är inte tillgänglig för din marknad, men kommer fungera i andra länder.",
					"edit_link": "Ändra",
					"merchant_agreement": {
						"before_link": "Jag godkänner",
						"link_text": "säljaravtalet",
						"after_link_one_product": "för den här produkten",
						"after_link_more_than_one_product": "för de här produkterna"
					},
					"pricing_annex": {
						"before_link": "Jag godkänner",
						"link_text": "Villkoren för prissättning",
						"after_link_one_product": "för den här produkten"
					}
				},
				"support_footer": {
					"text": "Support på engelska",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alla rättigheter förbehållna.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Villkor",
					"privacy_policy": "Integritetspolicy",
					"merchant_id": "Merchant ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Butikssupport",
					"recaptcha": {
						"1_main_text": "Denna sida skyddas av reCAPTCHA och Googles",
						"2_privacy_policy": "Integritetspolicy",
						"3_and": "och",
						"4_terms_of_service": "Villkor",
						"5_apply": "gäller."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Priser för alla våra marknader",
					"title_us": "Priser",
					"subtitle": "Du debiteras bara en avgift per transaktion. Det är smoooth!",
					"table": {
						"country": "Land",
						"price_column_heading": "Avgift per transaktion",
						"global": "Global",
						"title": {
							"kp": "Betalmetoder",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna som betalningsmetod"
						},
						"headers": {
							"kp_one": "Serviceavgift"
						}
					},
					"buttons": {
						"back": "Tillbaka"
					},
					"foot_notes": {
						"global_price": "* Handlares lokala valuta"
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Första transaktionen",
						"content": "Innan vi kan granska dina utbetalningsuppgifter behöver vi en första transaktion. Vill du inte spendera dina egna pengar? Inga problem! ",
						"button": "Fejka den!"
					},
					"transactions": {
						"title": "Godkänn transaktioner",
						"content": "Du kan fejka godkännandet av transaktionen från salesforce",
						"button": "Godkänn"
					},
					"payouts": {
						"title": "Godkänn utbetalningar",
						"content": "Du kan fejka godkännandet av utbetalningar från salesforce",
						"button": "Godkänn"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Standardkonto",
						"additional": "Ytterligare bankkonto {index}",
						"normal": "Bankkonto {index}"
					},
					"currency_code": {
						"label": "Valuta"
					},
					"country_of_bank_account": {
						"label": "Land"
					},
					"account_number": {
						"label": {
							"default": "Kontonummer",
							"MX_LOCAL": "CLABE-nummer"
						}
					},
					"account_holder": {
						"label": "Kontoinnehavare"
					},
					"routing_number": {
						"label": "Clearingnummer"
					},
					"transit_number": {
						"label": "Transitnummer"
					},
					"institution_number": {
						"label": "Institutionsnummer"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Du kan redigera dina bankkontouppgifter när du har slutfört din onboarding"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Juridiskt företagsnamn"
					},
					"country": {
						"label": "Land"
					},
					"registrationId": {
						"label": {
							"default": "Registreringsnummer",
							"AT": "Registreringsnummer",
							"AU": "ACN-nummer",
							"CA": "Företagsnummer",
							"ES": "Företagets NIF/NIE/DNI",
							"GB": "Organisationsnummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"US": "Arbetsgivarnummer"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Registreringsdomstol"
					},
					"goodsCategory": {
						"label": "Varukategori"
					},
					"registered": {
						"label": {
							"default": "Registrerat företag",
							"AU": "Företaget har ett ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Företag föremål för moms",
							"AU": "Företag med australiskt organisationsnummer",
							"ES": "Företaget har ett NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Momsregistreringsnummer",
							"AU": "Australiskt organisationsnummer",
							"ES": "Företagets NIF/NIE/DNI"
						}
					},
					"storeName": {
						"label": "Butiksnamn"
					},
					"website": {
						"label": "Webbsida"
					},
					"email": {
						"label": "E-postadress till kundtjänst"
					},
					"entityType": {
						"label": "Entitetstyp"
					},
					"toc_data": {
						"label": "Villkor",
						"toc_approval_text": {
							"before_link": "Dina",
							"link_text": "villkor",
							"after_link": "accepterade den {date}",
							"merchant_agreement": {
								"before_link": "Ditt",
								"link_text": "säljaravtal",
								"after_link": "godkänt den {date}"
							},
							"pricing_annex": {
								"before_link": "Din",
								"link_text": "prisbilaga",
								"after_link": "godkänd den {date}"
							}
						}
					},
					"companyName": {
						"label": "Partnerskapsnamn"
					},
					"registeredCompanyName": {
						"label": "Företagsnamn"
					},
					"address": {
						"label": "Adress"
					},
					"operatingAddress": {
						"label": "Verksamhetsadress"
					},
					"organizationEntityType": {
						"label": "Skatteklassificering"
					}
				},
				"api_key_dialog": {
					"title": "Klarna API-nycklar skapade",
					"subtitle": "Nycklarna visas bara en gång. Klicka på knappen nedan för att ladda ner dina nycklar innan du stänger det här fönstret.",
					"key_box": {
						"username": {
							"label": "Klarna API-användarnamn"
						},
						"password": {
							"label": "Klarna API-lösenord"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Ladda ner som .txt"
					}
				},
				"platform_instructions": {
					"step": "Steg {current}/{max}",
					"next": "Nästa",
					"back": "Tillbaka",
					"shopify": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för Shopify, följ den"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utökade integrationsguiden."
								}
							]
						},
						{
							"title": "Installera Klarna på din Shopifybutik",
							"step_instructions": [
								[
									{
										"text": "Gå till"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Konfigurationsguide Klarna som betalningsmetod för Shopify."
									}
								],
								[
									{
										"text": "Följ instruktionerna där för att slutföra din integration."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för Shopify, följ den"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utökade integrationsguiden."
								}
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa \"Integration slutförd\"."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för Shopify, följ den"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utökade integrationsguiden."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Aktivera plugin för betalningsmetoden för Klarna för Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "För att kunna installera din Klarna-plugin behöver du ett fungerande Plentymarkets CERES-system."
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres-plugin"
									},
									{
										"text": "Det finns tillgänglig för nedladdning på plentyMarketplace. Därifrån omdirigeras du också till"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "installationsinstruktionerna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information om integration av Klarna med Plentymarkets Ceres, följ"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "den här länken."
									}
								]
							]
						},
						{
							"title": "Installation och inställningar",
							"step_instructions": [
								[
									{
										"text": "Installationen av din Klarna-plugin görs via"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Du omdirigeras också till plentyMarketplace från administratörsvyn i plentymarkets-systemet. En"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instruktion för hur du installerar plugins på plentymarkets"
									},
									{
										"text": "finns på plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information om integration av Klarna med Plentymarkets Ceres, följ"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "den här länken."
									}
								]
							]
						},
						{
							"title": "Pluginkonfiguration",
							"step_instructions": [
								[
									{
										"text": "Din plugin konfigureras direkt i respektive uppsättning. Genom att klicka på raden"
									},
									{
										"bold": "Klarna-plugin"
									},
									{
										"text": "öppnas konfigurationssidan."
									}
								],
								[
									{
										"text": "Konfigurationen är uppdelad i två delar:"
									},
									{
										"list": [
											[
												{
													"bold": "\"Authentication\":"
												},
												{
													"text": "Läge som avgör om det används för test- eller produktionsmiljö. Användarnamnet och lösenordet måste sparas beroende på läget."
												}
											],
											[
												{
													"bold": "\"General Settings\":"
												},
												{
													"text": "Här väljer du produkten du vill använda. Antingen Klarnas individuella betalmetod (Klarna Payment) eller hela Klarnas kassalösning (Klarna Checkout). När du väljer kassalösningen skrivs butikens kassasystem automatiskt över av Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Inga ytterligare inställningar behöver göras. Om du avaktiverar din plugin kommer detta att upphävas."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information om integration av Klarna med Plentymarkets Ceres, följ"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "den här länken."
									}
								]
							]
						},
						{
							"title": "Slutlig information",
							"step_instructions": [
								[
									{
										"text": "Följande systemkrav gäller:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets version 7"
											},
											{
												"text": " Ceres- och IO-plugins installerade "
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information om integration av Klarna med Plentymarkets Ceres, följ"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "den här länken."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Aktivera plugin för Klarna Checkout för WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Först måste du se till att du har en plugin för Klarna Checkout för WooCommerce installerad. Om du inte har den än, gå till"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								],
								[
									{
										"text": "När du har dina Klarna API-nycklar, gå till “Settings” och sen “Checkout” i din användarpanel för WooCommerce. Välj Klarna Checkout."
									}
								],
								[
									{
										"text": "Aktivera Klarna Checkout genom att markera kryssrutan “Enable Klarna Checkout”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för WooCommerce, kolla in deras"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utökade guide."
									}
								]
							]
						},
						{
							"title": "Konfigurera dina inställningar",
							"step_instructions": [
								[
									{
										"text": "Konfigurera inställningarna för din Klarna Checkout. Notera att fältet “Title” används för att sätta namnet på betalmetoden i din utcheckning och orderbekräftelse (dvs Klarna Checkout)."
									}
								],
								[
									{
										"text": "Markera kryssrutan “Test mode” om du vill göra beställningar med dina testnycklar."
									}
								],
								[
									{
										"text": "Nu är det dags att fylla i inställningar för ditt land. Om du är baserad i Europa, klicka på “expand” under Europasektionen. Om du är baserad i USA, klicka på “expand” under USA-sektionen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för WooCommerce, kolla in deras"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utökade guide."
									}
								]
							]
						},
						{
							"title": "Lägg till dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Lägg till dina Klarna API-nycklar i fälten Klarna API-användarnamn och Klarna API-lösenord."
									}
								],
								[
									{
										"text": "Spara dina inställningar."
									}
								],
								[
									{
										"text": "Det sista du behöver göra är att sätta Klarna Checkout som din standardbetalmetod. Gå till “Settings” och sen “Payments” i din användarpanel för WooCommerce. Leta upp sektionen “Payment methods” och välj Klarna Checkout som standardbetalmetod."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för WooCommerce, kolla in deras"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utökade guide."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "Se till att aktivera"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "“pretty permalinks”"
									},
									{
										"text": "i din WordPress-installation. Annars kommer inte callbacks från Klarna till din butik att fungera och beställningar kommer inte uppdateras med korrekt status/information."
									}
								],
								[
									{
										"text": "Om du vill hantera dina beställningar från Klarna direkt i WooCommerce behöver du installera en plugin för"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna Order Management"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Se till att Klarna Checkout visas som förväntat genom att lägga en artikel i varukorgen och fortsätta till betalning (undvik att göra en faktisk beställning)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för WooCommerce, kolla in deras"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utökade guide."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för WooCommerce, följ den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Installera och aktivera plugin för betalningar med Klarna",
							"step_instructions": [
								[
									{
										"text": "Installera"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Klarna som betalningsmetod för WooCommerce."
									}
								],
								[
									{
										"text": "På ditt WooCommerce-konto, gå till"
									},
									{
										"bold": "Inställningar → Betalningar → Klarna som betalningsmetod."
									}
								],
								[
									{
										"text": "Aktivera Klarna som betalningsmetod genom att markera kryssrutan Aktivera Klarna som betalningsmetod."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för WooCommerce, följ den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Konfigurera inställningar för ditt land",
							"step_instructions": [
								[
									{
										"text": "Fyll i inställningar för ditt land. Varje Klarna-land har sin egen uppsättning landsspecifika inställningar. Genom att lägga till säljaruppgifter för ett specifikt land aktiverar du även Klarna som betalningsmetod som tillgänglig betalningsmetod för det landet."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för WooCommerce, följ den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Fyll i dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Ange dina Klarna API-nycklar i fälten för Klarna API-användarnamn och Klarna API-lösenord."
									}
								],
								[
									{
										"text": "Spara dina inställningar."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för WooCommerce, följ den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa ”Integration slutförd”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för WooCommerce, följ den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utökade integrationsguiden."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Konfigurera dina inställningar för att aktivera Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Först måste du se till att du har modulen för Klarna Checkout för Magento installerad. Om du inte har den än, gå till"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								],
								[
									{
										"text": "När du har dina Klarna API-nycklar, öppna din användarpanel i Magento. Gå till “Stores” → ”Configuration” → ”Sales” → ”Payment methods” → ”Klarna” → ”Klarna API”."
									}
								],
								[
									{
										"text": "Expandera “Klarna API”-sektionen och fyll i din API-version, Klarna API-användarnamn och Klarna API-lösenord. Se till att avaktivera testläget om du är redo att gå live med din webbplats."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Magento, kolla in deras"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "utökade guide."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "När dina inställningar är gjorda behöver du kontrollera att Klarna Checkout är aktiverat i dina utcheckningsalternativ."
									}
								],
								[
									{
										"text": "Gå till “Stores” → ”Configuration” → ”Sales” → ”Checkout” → ”Klarna Checkout options” i din användarpanel för Magento."
									}
								],
								[
									{
										"text": "Klarna Checkout är normalt sett redan aktiverat, annars väljer du"
									},
									{
										"bold": "Enable"
									},
									{
										"text": "under “Enable Klarna Checkout”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							]
						},
						{
							"title": "Installera och aktivera modulen för Klarna som betalningsmetod",
							"step_instructions": [
								[
									{
										"text": "Besök"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Användarguiden för att installera Klarna på Magento"
									},
									{
										"text": "och följ instruktionerna där för att installera och konfigurera modulen på ditt Magento-konto."
									}
								]
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa ”Integration slutförd”."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Aktivera plugin för Klarna som betalningsmetod för Shopware",
							"step_instructions": [
								[
									{
										"text": "Se först och främst till att du har installerat plugin för Klarna som betalningsmetod för Shopware. Om du inte har denna plugin än, gå till"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								],
								[
									{
										"text": "I ett kommande steg måste du importera en plugin för Klarna som betalningsmetod till Shopware genom att klicka vidare"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed → Upload Plugin."
									},
									{
										"text": "Klicka"
									},
									{
										"bold": "Select"
									},
									{
										"text": "och välja ZIP-filen för plugin för Klarna som betalningsmetod. Bekräfta genom att klicka"
									},
									{
										"bold": "Upload Plugin."
									},
									{
										"text": "Din plugin kan nu hittas i din plugin manager."
									}
								],
								[
									{
										"text": "Installera plugin genom att klicka på den"
									},
									{
										"bold": "gröna “+”-"
									},
									{
										"text": "symbolen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Konfigurera plugin för Klarna som betalningsmetod för Shopware",
							"step_instructions": [
								[
									{
										"text": "Navigera till inställningar för plugins genom att klicka"
									},
									{
										"bold": "Konfiguration → Grundinställningar → Sök efter Klarna som betalningsmetod"
									}
								],
								[
									{
										"text": "Fyll i dina Klarna API-nycklar i fälten"
									},
									{
										"bold": "Klarna API-användarnamn"
									},
									{
										"text": "och"
									},
									{
										"bold": "Klarna API-lösenord"
									},
									{
										"text": "och spara dina ändringar."
									}
								],
								[
									{
										"text": "Se till att du använder liveläget och dina Klarna API-nycklar."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Konfigurera din/dina gateway/gateways för Klarna som betalningsmetod",
							"step_instructions": [
								[
									{
										"text": "Innan du använder din/dina gateway/gateways för Klarna som betalningsmetod. Du kan hitta dessa genom att klicka"
									},
									{
										"bold": "Configuration → Payment methods"
									}
								],
								[
									{
										"text": "Alla Klarna-gateways för Klarna som betalningsmetod är installerade. Öppna den/de gateway/gateways för Klarna som betalningsmetod som du registrerade dig för och aktivera dem genom att markera"
									},
									{
										"bold": "Activated."
									},
									{
										"text": "Spara dina ändringar."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Konfigurera dina fraktkostnader",
							"step_instructions": [
								[
									{
										"text": "Konfigurera fraktkostnaderna för din/dina gateway/gateways för Klarna som betalningsmetod genom att klicka"
									},
									{
										"bold": "Configuration → Shipping cost"
									}
								],
								[
									{
										"text": "Välj de fraktmetoder som ska vara tillgängliga för Klarna genom att klicka på"
									},
									{
										"bold": "pennsymbolen."
									}
								],
								[
									{
										"text": "Välj fliken för val av betalningsmetod och flytta din/dina gateway/gateways för Klarna som betalningsmetod från"
									},
									{
										"bold": "Available"
									},
									{
										"text": "till"
									},
									{
										"bold": "Selected."
									},
									{
										"text": "Spara dina inställningar"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Aktivera din plugin för Klarna som betalningsmetod",
							"step_instructions": [
								[
									{
										"text": "I nästa steg måste du aktivera din plugin för Klarna som betalningsmetod. Klicka vidare"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed"
									},
									{
										"text": "för att komma till Plugin Manager."
									}
								],
								[
									{
										"text": "Aktivera plugin genom att klicka på den"
									},
									{
										"bold": "röda “X”-"
									},
									{
										"text": "symbolen."
									}
								],
								[
									{
										"text": "Du kommer bli frågad om du vill tömma cacheminnet. Klicka på"
									},
									{
										"bold": "Yes."
									},
									{
										"text": "Notera att du kommer behöva tömma cacheminne och sammanställa teman varje gång du ändra något i modulinställningarna eller betalmetoderna från Klarna."
									}
								],
								[
									{
										"text": "För att helt aktivera din plugin för Klarna som betalningsmetod måste butikstemat kompileras om. Klicka på"
									},
									{
										"bold": "Compile themes"
									},
									{
										"text": "när du blir förfrågad."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "Se till att ha PHP-förlängningen bcmath installerad på din server för att undvika avrundningsfel. Du hittar guiden"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "här"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Starta om ditt backendsystem en gång för att se till att alla konfigurationer gjorts tillgängliga i din butik."
									}
								],
								[
									{
										"text": "Se till att butikens Klarna Payment-produkt(er) visas som förväntat genom att lägga en artikel i varukorgen, välja Klarna som betalmetod och fortsätta till betalning (undvik att göra en faktisk beställning)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Aktivera plugin för Klarna Checkout för Shopware",
							"step_instructions": [
								[
									{
										"text": "Först måste du se till att du har en plugin för Klarna Checkout för Shopware (version 5.2.17 eller senare) installerad. Om du inter har den än, gå till"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								],
								[
									{
										"text": "I nästa steg behöver du importera din plugin för Klarna Checkout till Shopware genom att klicka"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed → Upload Plugin."
									},
									{
										"text": "Klicka"
									},
									{
										"bold": "Select"
									},
									{
										"text": "och välj zipfilen med Klarna Checkout Plugin. Bekräfta genom att klicka"
									},
									{
										"bold": "Upload Plugin."
									},
									{
										"text": "Din plugin kan nu hittas i din plugin manager."
									}
								],
								[
									{
										"text": "Installera plugin genom att klicka på den"
									},
									{
										"bold": "gröna “+”-"
									},
									{
										"text": "symbolen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Konfigurera plugin för Klarna Checkout för Shopware",
							"step_instructions": [
								[
									{
										"text": "Navigera till inställningar för plugins genom att klicka"
									},
									{
										"bold": "Configuration → Basic settings → Sök efter Klarna Checkout"
									}
								],
								[
									{
										"text": "Fyll i dina Klarna API-nycklar i fälten"
									},
									{
										"bold": "Klarna API-användarnamn"
									},
									{
										"text": "och"
									},
									{
										"bold": "Klarna API-lösenord"
									},
									{
										"text": "och spara dina ändringar."
									}
								],
								[
									{
										"text": "Se till att du använder liveläget och dina Klarna API-nycklar."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Aktivera Klarna Checkout Payment gateway",
							"step_instructions": [
								[
									{
										"text": "Innan du använder Klarna behöver du aktivera din Klarna Payment gateway. Du hittar dessa genom att klicka"
									},
									{
										"bold": "Configuration → Payment methods"
									}
								],
								[
									{
										"text": "Öppna Klarna Checkout gateway och aktivera den genom att markera kryssrutan"
									},
									{
										"bold": "Activated."
									},
									{
										"text": "Spara dina ändringar."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Konfigurera dina fraktkostnader",
							"step_instructions": [
								[
									{
										"text": "Konfigurera dina fraktkostnader för din Klarna Checkout genom att klicka"
									},
									{
										"bold": "Configuration → Shipping cost"
									}
								],
								[
									{
										"text": "Välj de fraktmetoder som ska vara tillgängliga för Klarna genom att klicka på"
									},
									{
										"bold": "pennsymbolen."
									}
								],
								[
									{
										"text": "Välj fliken “Payment method selection” och flytta din Klarna Checkout från"
									},
									{
										"bold": "Available"
									},
									{
										"text": "till"
									},
									{
										"bold": "Selected."
									},
									{
										"text": "Spara dina inställningar"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Aktivera din plugin för Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "I nästa steg behöver du aktivera din plugin för Klarna Checkout. Klicka"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed"
									},
									{
										"text": "för att komma till Plugin Manager."
									}
								],
								[
									{
										"text": "Aktivera plugin genom att klicka på den"
									},
									{
										"bold": "röda “X”-"
									},
									{
										"text": "symbolen."
									}
								],
								[
									{
										"text": "Du kommer bli frågad om du vill tömma cacheminnet. Klicka på"
									},
									{
										"bold": "Yes."
									}
								],
								[
									{
										"text": "För att aktivera din plugin för Klarna Checkout helt och hållet måste butikstemat sammanställas igen. Klicka på"
									},
									{
										"bold": "Compile themes"
									},
									{
										"text": "när du blir förfrågad."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "Se till att ha PHP-förlängningen bcmath installerad på din server för att undvika avrundningsfel. Du hittar guiden"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "här"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Se till att “Additional address line 1” och “Additional address line 2” inte är markerade som obligatoriska."
									}
								],
								[
									{
										"text": "Starta om ditt backendsystem en gång för att se till att alla konfigurationer gjorts tillgängliga i din butik."
									}
								],
								[
									{
										"text": "Se till att din Klarna Checkout visas som förväntat genom att lägga en artikel i varukorgen, välja Klarna som betalmetod och fortsätta till betalning (undvik att göra en faktisk beställning)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Aktivera plugin för Klarna som betalningsmetod för Shopware",
							"step_instructions": [
								[
									{
										"text": "För att kunna installera din Klarna-plugin måste du köra systemet Shopware 6. Installationsriktlinjer kan hittas"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "här."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Installation och konfigurering. Det finns flera sätt att installera din Klarna-plugin.",
							"step_instructions": [
								[
									{
										"text": "First Run Wizard."
									}
								],
								[
									{
										"text": "Installation via Administration."
									}
								],
								[
									{
										"text": "Installation via Community Store Direct-nedladdning."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Aktivera plugin för Klarna som betalningsmetod för Shopware",
							"step_instructions": [
								[
									{
										"text": "Gå till översikten för dina plugins i Shopware Administration. Du kan nå den via"
									},
									{
										"bold": "Settings > System > Plugins."
									}
								],
								[
									{
										"text": "Välj"
									},
									{
										"bold": "Installera"
									},
									{
										"text": "från menyn (\"...\"). Du kommer få ett meddelande från Shopware om att din plugin har installerats."
									}
								],
								[
									{
										"text": "Av säkerhetskäl är din plugin installerad men inte aktiverad ännu. Du behöver optimera den med hjälp av dina inloggningsdata och individuella inställningar först."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Wizard",
							"step_instructions": [
								[
									{
										"text": "Efter att din plugin har aktiverats, vänligen gå till"
									},
									{
										"bold": "menyn (\"...\") > wizard.",
										"text": "Du kommer då att vidarebefordras till rutinen."
									}
								],
								[
									{
										"text": "Rutinen kommer vägleda dig genom hela konfigureringsprocessen och låter dig registrera dig hos Klarna om du inte har ett handlarkonto ännu."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Pluginkonfiguration",
							"step_instructions": [
								[
									{
										"bold": "Säljkanaler"
									},
									{
										"text": "Här väljer du om du vill använda följande inställningar för \"alla säljkanaler\" eller om de bara ska gälla för vissa, individuella säljkanaler."
									}
								],
								[
									{
										"bold": "API-inställningar."
									},
									{
										"text": "Användarnamn och lösenord för API: Fyll i dina API-nycklar för live- och testläget i motsvarande sektion."
									}
								],
								[
									{
										"text": "Du kan testa dina Klarna API-nycklar genom att klicka på"
									},
									{
										"bold": "Test API credentials",
										"text": "-knappen som hittas längst upp. Du kommer då få ett meddelande om ett lyckat test eller en indikation på vilka uppgifter som inte verkar stämma."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Aktivera/avaktivera plugin",
							"step_instructions": [
								[
									{
										"text": "Om du vill aktivera/avaktivera din plugin för Klarna som betalningsmetod eller se dess nuvarande status, gå till Shopware Admin och välj"
									},
									{
										"bold": "Settings > System > Plugins."
									}
								],
								[
									{
										"text": "Här kan du hitta den nuvarande statusen i tabellen under"
									},
									{
										"bold": "\"My Plugins\"."
									}
								],
								[
									{
										"text": "Status kan ändras genom att klicka på reglaget."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "Se till att ha PHP version >= 7.2. för att undvika avrundningsfel. "
									}
								],
								[
									{
										"text": "Full installation av Shopware"
									},
									{
										"bold": "(Storefront + Administration, inte headless)."
									}
								],
								[
									{
										"text": "Systemet måste vara åtkomligt utifrån för att uppdatera betalningsstatusen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För mer detaljerad information kring din integration för Shopware, kolla in vår"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utökade guide (på tyska)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för 3dcart, följ den"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Aktivera Klarna som betalningsmetod i Online Store Manager",
							"step_instructions": [
								[
									{
										"text": "Logga in på din"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager,"
									},
									{
										"text": "navigera till"
									},
									{
										"bold": "Settings → Payment."
									}
								],
								[
									{
										"text": "På Payment-sidan, klicka på"
									},
									{
										"bold": "Select Payment Methods"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Du kommer att se en lista över förinstallerade moduler. Leta upp modulen för Klarna och aktivera den med hjälp av reglaget."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för 3dcart, följ den"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Fyll i dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "När du har aktiverat modulen, ange ditt Klarna API-användarnamn (UID) i det angivna fältet. Du hittar detta i filen som du laddade ner tidigare."
									}
								],
								[
									{
										"text": "Klicka sen på"
									},
									{
										"bold": "Password Change"
									},
									{
										"text": "-länken och ange ditt Klarna API-lösenord i det angivna fältet."
									}
								],
								[
									{
										"text": "Under"
									},
									{
										"bold": "Language Country"
									},
									{
										"text": ", välj det språk som ska användas för Klarnas betalningsalternativ i butiken."
									}
								],
								[
									{
										"text": "Över användarnamnsfältet finns en kryssruta märkt"
									},
									{
										"bold": "”Test Mode”."
									},
									{
										"text": "Markera detta alternativ för att aktivera testläget. Detta låter dig lägga en order utan att behöva betala eller vidta några andra åtgärder medan du testar modulen."
									}
								],
								[
									{
										"text": "När du har gjort alla dina inställningar, klicka ”Save” i det övre högra hörnet."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för 3dcart, följ den"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utökade integrationsguiden."
									}
								]
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa ”Integration slutförd”."
									}
								],
								[
									{
										"text": "Om du aktiverade ”Test Mode” i föregående steg, gå tillbaka och säkerställ att det är avslaget samt spara inställningar innan du går live med din butik så att riktiga ordrar går igenom."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "För detaljerad information kring din integration för 3dcart, följ den"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utökade integrationsguiden."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för BigCommerce, följ den"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utökade integrationsguiden."
								}
							]
						},
						{
							"title": "Konfigurera dina BigCommerce-inställningar",
							"step_instructions": [
								[
									{
										"text": "I BigCommerce, gå till"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Store Setup › Payments,"
									},
									{
										"text": "och expandera Online Payment Methods-sektionen. Klicka sen på"
									},
									{
										"bold": "Set up"
									},
									{
										"text": "bredvid Klarna som betalningsmetod."
									}
								],
								[
									{
										"text": "Du kommer att tas till inställningsfliken för Klarna som betalningsmetod. Ange API-uppgifterna i filen du sparade i föregående avsnitt och kopiera användarnamnet och lösenordet till motsvarande fält."
									}
								],
								[
									{
										"text": "Spara dina ändringar när du är klar."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för BigCommerce, följ den"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utökade integrationsguiden."
								}
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa ”Integration slutförd”."
									}
								]
							],
							"alternate": [
								{
									"text": "För detaljerad information kring din integration för BigCommerce, följ den"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utökade integrationsguiden."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktivera modulen för Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Först måste du se till att du har modulen för Klarna Checkout för Prestashop installerad. Om du inte har den än, gå till"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								],
								[
									{
										"text": "Tyvärr, från och med 1 januari 2023 kommer dessa plug-in-program som utvecklats och ägs av Prestasworks A.B (SI) inte längre att distribueras gratis. Om du är intresserad av Klarna kan du köpa plug-in-programmet eller vänta på att Klarnas egna plug-ins förväntas släppas under andra kvartalet 2023."
									}
								],
								[
									{
										"text": "Logga in på din administratörssida hos Prestashop och gå till"
									},
									{
										"bold": "Modules → Modules."
									}
								],
								[
									{
										"text": "Sök efter “Klarna” i sökrutan och leta upp modulen för Klarna från Prestaworks AB. Klicka"
									},
									{
										"bold": "Configure."
									}
								]
							]
						},
						{
							"title": "Konfigurera dina modulinställningar för Klarna",
							"step_instructions": [
								[
									{
										"text": "Du är nu på sidan för modulinställingar. Över “General settings” kommer du se knappen"
									},
									{
										"bold": "Activate KCO in this shop"
									},
									{
										"text": "(Klarna Checkout V3). Välj"
									},
									{
										"bold": "Yes."
									}
								],
								[
									{
										"text": "Klicka"
									},
									{
										"bold": "Save"
									},
									{
										"text": "för att spara dina inställningar."
									}
								],
								[
									{
										"text": "Välj nu ditt försäljningsland i den vänstra menyn och fyll i dina Klarna API-nycklar under"
									},
									{
										"bold": "Klarna API-användarnamn"
									},
									{
										"text": "och"
									},
									{
										"bold": "Klarna API-lösenord."
									}
								],
								[
									{
										"text": "Klicka"
									},
									{
										"bold": "Spara."
									}
								]
							]
						},
						{
							"title": "Sista stegen",
							"step_instructions": [
								[
									{
										"text": "Kontrollera att testläget är avaktiverat om du är redo att gå live med din webbplats. Du kan göra detta under fliken"
									},
									{
										"bold": "Common Settings."
									},
									{
										"text": "Knappen"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "ska vara satt till"
									},
									{
										"bold": "No."
									}
								],
								[
									{
										"text": "Under"
									},
									{
										"bold": "Common Settings,"
									},
									{
										"text": "se till att du ställer in hur du vill hantera beställningar, fakturautskick, etc."
									}
								],
								[
									{
										"text": "Se till att din Klarna Checkout visas som förväntat genom att lägga en artikel i varukorgen och fortsätta till betalning (undvik att göra en faktisk beställning)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							]
						},
						{
							"title": "Installera och aktivera modulen för Klarna som betalningsmetod",
							"step_instructions": [
								[
									{
										"text": "Öppna"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Instruktionssidan för Klarna som betalningsmetod för Prestashop"
									},
									{
										"text": "och följ instruktionerna där för att installera och konfigurera modulen på ditt Prestashop-konto."
									}
								]
							]
						},
						{
							"title": "Gör ett provköp",
							"step_instructions": [
								[
									{
										"text": "För att verifiera att integrationen är korrekt gjord, gör ett provköp i din butik."
									}
								],
								[
									{
										"text": "När du har lagt din order, gå till"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordrar i Butiksportalen,"
									},
									{
										"text": "leta upp din order och avbryt den så att du slipper betala för den."
									}
								],
								[
									{
										"text": "När din integration är färdig kommer den banner som är längst upp på sidan att byta färg till grön och visa ”Integration slutförd”."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Generera dina Klarna API-nycklar.",
							"step_instructions": [
								[
									{
										"text": "Du kommer att behöva dessa uppgifter för att integrera Klarna i din butik."
									}
								]
							]
						},
						{
							"title": "Lägg till Klarna som ny betalningsmetod.",
							"step_instructions": [
								[
									{
										"text": "På Jumpseller-administratörspanelen och navigera till Inställningar > Betalningar, hitta \"Klarna\" i listan med kryssrutor och klicka \"Lägg till metod\"."
									}
								]
							]
						},
						{
							"title": "Konfigurera vår nya betalningsmetod.",
							"step_instructions": [
								[
									{
										"text": "På Klarna-konfigurationspanelen (Jumpseller-administratörspanelen och navigera till Inställningar > Betalningar > Klarna), (i) lägg till Klarna API-uppgifter som genererades i första steget, (ii) välj de EMD-paket du vill/måste dela med Klarna, och (iii) välj om du behöver aktivera beställningarna automatiskt (standard är nej)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integrera Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Se integrationsguiden på"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Engelska"
									},
									{
										"text": "och på"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Holländska"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrera Shoper",
							"step_instructions": [
								[
									{
										"text": "Se integreringsguiden om"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "Shoper-webbplatsen"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrera Timma",
							"step_instructions": [
								[
									{
										"text": "Se integreringsguiden om"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "Timma-webbplatsen"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							]
						},
						{
							"title": "Integrera med SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Följ instruktionerna på"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "webbplatsen SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Generera och spara dina Klarna API-nycklar",
							"step_instructions": [
								[
									{
										"text": "Generera nya API-nycklar och ladda ner filen på din dator. Öppna filen och behåll den öppen då du behöver dessa API-nycklar i nästa sektion."
									}
								]
							]
						},
						{
							"title": "Integrera med Workstand",
							"step_instructions": [
								[
									{
										"text": "Följ instruktionerna på"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "webbplatsen Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Läs dokumentationen för vår plugin",
							"step_instructions": [
								[
									{
										"text": "Gå till vår"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentationssida"
									}
								]
							]
						},
						{
							"title": "Aktivera Klarna Checkout-modulen för JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Se till att du har installerat det officiella Klarna-tillägget. Om du inte har det än,"
									},
									{
										"text": "gå till"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Läs dokumentationen för vår plugin",
							"step_instructions": [
								[
									{
										"text": "Gå till vår"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentationssida"
									}
								]
							]
						},
						{
							"title": "Aktivera Klarnas betalningsmodul för JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Se till att du har installerat det officiella Klarna-tillägget. Om du inte har det än,"
									},
									{
										"text": "gå till"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "den här sidan"
									},
									{
										"text": "för att få den."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Här är vad du behöver göra härnäst",
							"step_instructions": [
								[
									{
										"bold": "Generera dina Klarna API-nycklar."
									},
									{
										"text": "Du behöver dessa nycklar för att integrera Klarna i din butik."
									}
								],
								[
									{
										"bold": "Lägg till Klarna API-nycklarna i ditt backendsystem för att aktivera Klarna."
									},
									{
										"text": "Kolla in vår"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Developer Portal"
									},
									{
										"text": "för ytterligare support."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Förnamn",
							"error": "Vänligen ange ett förnamn"
						},
						"last_name": {
							"label": "Efternamn",
							"error": "Vänligen ange ett efternamn"
						},
						"dateOfBirth": {
							"label": {
								"default": "Födelsedatum (DD/MM/ÅÅÅÅ)",
								"without_format": "Födelsedatum",
								"US": "Födelsedatum (MM/DD/ÅÅÅÅ)"
							},
							"error": "Ange ett giltigt datum",
							"error_too_young": "Du måste vara minst 18 år gammal för att sälja med Klarna"
						},
						"address": {
							"label": "Hemadress",
							"error": "Vänligen ange en adress"
						},
						"city": {
							"label": "Stad",
							"error": "Vänligen ange en stad"
						},
						"country": {
							"label": "Land",
							"error": "Vänligen välj ett land"
						},
						"postal_code": {
							"label": {
								"default": "Postnummer",
								"US": "Postnummer"
							},
							"error": {
								"default": "Vänligen ange en giltig postkod",
								"US": "Ange ett giltigt postnummer"
							}
						},
						"region": {
							"label": "Region (valfritt)",
							"label_summary": "Region"
						},
						"state": {
							"label": "Stat",
							"error": "Vänligen ange en stat/provins"
						},
						"role_question": {
							"OWNER": "Är den här personen en ägare?",
							"BENEFICIAL_OWNER": "Kontrollerar denna person mer än 25% av andelarna eller rösträtten?",
							"ULTIMATE_BENEFICIAL_OWNER": "Denna individ äger eller kontrollerar mer än 25% av andelarna eller rösträtten"
						},
						"is_person_pep": [
							{
								"text": "Är denna individ en"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "person i politiskt utsatt ställning (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "nära familj till"
							},
							{
								"text": "eller"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "känd medarbetare"
							},
							{
								"text": "till en sådan person?"
							}
						],
						"pep_relationship": {
							"label": "Relation",
							"error": "Vänligen välj vilken relation den här individen har till personen i en politiskt utsatt ställning"
						},
						"pep_position": {
							"label": "Person i en politiskt utsatt ställnings roll",
							"error": "Vänligen välj vilken roll personen i en politiskt utsatt ställning har"
						},
						"personal_id_question": "Den här personen har inte ett personnummer",
						"personal_id": {
							"US": {
								"label": "Social Security Number (4 sista siffrorna)",
								"label_summary": "Social Security Number (SSN)"
							},
							"US_FULL_SSN": {
								"label": "Social Security Number (SSN)",
								"label_summary": "Social Security Number (SSN)"
							},
							"CA": {
								"label": "Social Insurance Number (SIN) eller passnummer",
								"label_summary": "Social Insurance Number (SIN) eller passnummer"
							},
							"SE": {
								"label": "Personnummer (PNO)",
								"label_summary": "Personnummer (PNO)"
							},
							"FI": {
								"label": "Personkod (HETU)",
								"label_summary": "Personnummer (HETU)"
							},
							"NO": {
								"label": "Nationellt ID-nummer",
								"label_summary": "Nationellt ID-nummer"
							},
							"DK": {
								"label": "Personnummer",
								"label_summary": "Personnummer (CPR)"
							},
							"IT": {
								"label": "Skattekod",
								"label_summary": "Skattekod"
							},
							"ES": {
								"label": "Personnummer",
								"label_summary": "Personnummer (DNI)"
							},
							"PL": {
								"label": "Personnummer",
								"label_summary": "Personligt identifieringsnummer (PESEL)"
							},
							"default": {
								"label": "Passnummer",
								"label_summary": "Passnummer"
							},
							"value": "Konfidentiell"
						},
						"registration_number": {
							"label": "Enterprise Identification Number (EIN)",
							"error": "Vänligen ange EIN enligt formatet XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Butiksnamn",
							"error": "Vänligen ange ett giltigt företagsnamn"
						},
						"legal_company_name": {
							"label": "Juridiskt företagsnamn",
							"error_label": "Vänligen ange det juridiska namnet för företaget"
						},
						"add_person": "Lägg till person",
						"remove": "Ta bort",
						"edit": "Ändra"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Butiks-ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Marknadsföringsmaterial",
						"text": "Nu är du en del av Klarnafamiljen. Här är lite material och annat som hjälper dig att komma igång.",
						"link": "Ladda ner"
					},
					"invite_more_users": {
						"title": "Bjud in fler användare",
						"text": "Bjud in dina samarbetspartners till Butiksportalen. Du kan ställa in anpassade behörigheter för varje person.",
						"link": "Bjud in användare"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produkter och priser",
					"subtitle": "{country}",
					"pricing": "Priser för {country}",
					"monthly_fee": "månadsavgift",
					"transaction_fee": "transaktionsavgift",
					"before_link": "Jag godkänner Klarnas",
					"link_text": "villkor",
					"after_link_one_product": "för denna produkt",
					"after_link_more_than_one_product": "för dessa produkter",
					"product_not_available_in_your_country": "* Den här produkten är inte tillgänglig för din marknad, men kommer fungera i andra länder."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installerad"
						},
						"in_progress": {
							"text": "Pågående"
						}
					}
				},
				"phone_collection_block": {
					"title": "Har du problem med din Klarnaintegration?",
					"description": "Lämna ditt nummer nedan så ringer en av våra medarbetare och hjälper dig att lägga till Klarna i din onlinebutik.",
					"success_banner": "Tack. Vi återkommer till dig så snart som möjligt.",
					"submit": "Skicka",
					"fields": {
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Du måste inkludera landskoden, t.ex. +46 8 123 456",
							"errors": {
								"required": "Telefonnummer måste fyllas i",
								"invalid": "Ogiltigt telefonnummer"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Vem skriver på kontrakt för ditt företag?",
						"managed": "Vem skriver på kontrakt för företaget?",
						"recollection": "Vem har rättighet att signera för ditt bolag?"
					},
					"subtitle": {
						"unmanaged": "Ditt företag är på väg att sluta ett avtal med Klarna. Vi behöver verifiera vem som är juridiskt auktoriserad att underteckna kontrakt.",
						"managed": "Ange information om samtliga auktoriserade firmatecknare för ditt företag som ingår avtalet. Vi är juridiskt skyldiga att validera representanternas rätt som firmatecknare. Om ingen i listan undertecknat avtalet, välj \"Lägg till person\" ange den information som begärs.",
						"recollection": "Eftersom ditt företag har ett aktivt avtal med Klarna behöver du ange information om dess behöriga firmatecknare som Klarna enligt lag behöver samla in och verifiera. "
					},
					"form_title": "Ange information",
					"robot_message": {
						"unmanaged": "Detta är oftast styrelseordföranden eller högt uppsatta chefer, såsom VD eller ekonomichef. Om du anger två eller fler personer kan det skynda på godkännandet av kontraktet.",
						"managed": "Detta är oftast styrelseordföranden eller högt uppsatta chefer, såsom VD eller ekonomichef. Om du anger två eller fler personer kan det skynda på godkännandet av kontraktet."
					},
					"error_tooltip": {
						"too_young": "Den här personen kan inte skicka in ansökan eftersom personen inte fyllt {minAge} år."
					},
					"alert_all_too_young": "Alla personer som ingår avtalet måste vara över {minAge} år. Fortsätt genom att lägga till en sökande som är minst {minAge} år gammal.",
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka",
						"add_person": "+ Lägg till person"
					},
					"role": {
						"recollection": "Firmatecknare"
					}
				},
				"application_summary": {
					"title": "Granska och skicka in ansökan.",
					"subtitle": {
						"unmanaged": "Ta en titt på dina uppgifter innan du skickar in dem.",
						"managed": "Ta en extra titt på uppgifterna innan du skickar in dem."
					},
					"stakeholders": {
						"title": "Företagsledning",
						"subtitle": "Intressent {index}"
					},
					"businessDetailsCard": {
						"title": "Företagsuppgifter"
					},
					"businessDetailsCardFields": {
						"companyName": "Företagsnamn",
						"organizationEntityType": "Skatteklassificering",
						"organizationRegistrationAuthority": "Registreringsdomstol",
						"goodsCategory": "Varukategori",
						"registrationId": {
							"default": "Registreringsnummer",
							"AT": "Registreringsnummer",
							"AU": "ACN-nummer",
							"CA": "Företagsnummer",
							"ES": "Företagets NIF/NIE/DNI",
							"GB": "Organisationsnummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Företagsnummer",
							"US": "Arbetsgivarnummer"
						},
						"registered": {
							"default": "Registrerat företag",
							"AU": "Företaget har ett ACN"
						},
						"subjectToVat": {
							"default": "Företag föremål för moms",
							"AU": "Företag med australiskt organisationsnummer"
						},
						"vatId": {
							"default": "Momsregistreringsnummer",
							"AU": "Australiskt organisationsnummer",
							"NZ": "GST-nummer",
							"ES": "Företagets NIF/NIE/DNI"
						},
						"storeName": "Butiksnamn",
						"storeName_us": "Varumärkesnamn/Bifirma",
						"website": "Webbsida",
						"email": "E-postadress till kundservice",
						"entityType": "Entitetstyp"
					},
					"companyRegistrationAddressCard": {
						"title": "Registreringsadress"
					},
					"companyAddressCard": {
						"title": "Företagsadress"
					},
					"operatingAddressCard": {
						"title": "Verksamhetsadress"
					},
					"documentsCard": {
						"title": "Uppladdade dokument"
					},
					"buttons": {
						"edit": "Ändra",
						"back": "Tillbaka",
						"submit": "Skicka"
					},
					"noTermsAccepted": "Läs och godkänn villkoren",
					"noTermsAcceptedWithPricingAnnex": "Läs och godkänn säljaravtalet och prisvillkoren"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Vem leder företaget?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi är juridiskt skyldiga enligt EU:s lagstiftning om penningtvätt ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						],
						"US": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"CA": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						]
					},
					"infobox": {
						"default": "Ange personuppgifter och hemadress för företagets Vd.",
						"US": "Ange personuppgifter och hemadress för majoritetsägaren eller en högt uppsatt chef, såsom VD, ekonomichef eller motsvarande.",
						"CA": "Ange personuppgifter och hemadress för majoritetsägaren eller en högt uppsatt chef, såsom VD, ekonomichef eller motsvarande."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Är verksamheten ett offentligt företag eller ensamt ägt av ett offentligt företag?",
					"title_stakeholder": "Vem leder företaget?",
					"subtitle": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information.",
					"subtitle_stakeholder": "Ange personuppgifter och hemadress för företagets Vd.",
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"bank_account": {
					"title": {
						"default": "Vad är dina bankkontouppgifter?"
					},
					"subtitle": {
						"US": "Klarnatransaktioner kommer att föras över till det här konto.",
						"default": "Vi kommer använda dessa bankkontouppgifter för att föra över betalningar från din försäljning."
					},
					"no_more_bank_accounts": "Du har redan lagt till bankkonto för alla valutor som stöds. Snyggt jobbat!",
					"robot_message_general": "Ditt standardkonto måste vara hos en bank i landet där ditt företag är registrerat. Du måste även ha ett konto för varje valuta som du planerar att acceptera.",
					"robot_message": "IBAN står för International Bank Account Number (internationellt bankkontonummer) och ges av din bank. Till exempel GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Kontonumret tillhandahålls av din bank och innehåller mellan 6 och 10 siffror. Tex.: 12345678",
						"US": "Kontonumret tillhandahålls av din bank och innehåller mellan 5 och 17 siffror. Tex.: 12345678",
						"GB": "Kontonummer anges av din bank och innehåller åtta 8. t.ex. 12345678. Vissa banker i Storbritannien erbjuder kortare kontonummer (t.ex. 7 siffror). I dessa fall kommer nollor att läggas till i början av ditt nummer för att fylla på till 8 siffror."
					},
					"robot_message_revolut": "Det kontonummer (IBAN) du angett kan inte ta emot nationella GBP-betalningar. Du måste kontakta din bank och begära kontouppgifter som stöder nationella GBP-överföringar.",
					"robot_message_local": "Det IBAN du angett är ett lokalt IBAN-nummer som inte stöds av oss. Du måste kontakta banken och få ditt personliga IBAN eller använda ett annat konto för att ansluta till Klarna.",
					"buttons": {
						"add_bank_account": "+ Lägg till bankkonto",
						"skip": "Hoppa över (för tillfället)",
						"remove": "Ta bort",
						"submit": "Skicka",
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"fields": {
						"currency_code": {
							"label": "Valuta",
							"disable_reason": {
								"account_in_merchant_currency_required": "Standardvalutan är {currency} på grund av landet ditt företag är registrerat i."
							},
							"errors": {
								"general": "Vänligen välj en valuta"
							}
						},
						"country_of_bankaccount": {
							"label": "Land",
							"errors": {
								"general": "Vänligen välj ett land"
							}
						},
						"iban_account_number": {
							"label": "Kontonummer (IBAN)",
							"errors": {
								"general": "Vänligen ange ett bankkontonummer (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Använd detta konto för ospecificerade valutor",
							"tooltip": "Order i valutor som inte finns på denna sida kommer att betalas ut till detta konto. Din bank kan ta ut en extra avgift för vissa valutor."
						},
						"local_account_number": {
							"label": {
								"default": "Kontonummer",
								"MX": "CLABE-nummer"
							},
							"errors": {
								"general": {
									"default": "Vänligen ange ett bankkontonummer",
									"MX": "Ange ett giltigt CLABE-nummer"
								}
							}
						},
						"account_holder": {
							"label": "Kontoinnehavare",
							"errors": {
								"general": "Ange kontoinnehavarens namn (max 70 tecken)."
							}
						},
						"transit_number": {
							"label": "Transitnummer",
							"errors": {
								"general": "Ange ett giltigt transitnummer"
							}
						},
						"institution_number": {
							"label": "Institutionsnummer",
							"errors": {
								"general": "Ange ett giltigt institutionsnummer"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Ange ett giltigt BSB (bank state branch)"
								}
							},
							"tooltip": {
								"AU": "BSB-koden ska vara 6 numeriska siffror delade med en -. Exempel: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Clearingnummer",
								"GB": "Startkod"
							},
							"errors": {
								"general": {
									"default": "Vänligen ange ett giltigt clearingnummer",
									"GB": "Ange en giltig startkod"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Vem leder företaget?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi är juridiskt skyldiga enligt EU:s lagstiftning om penningtvätt ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						],
						"GB": [
							{
								"text": "Vi är juridiskt skyldiga att samla in den här informationen. Se till att dina uppgifter i Companies House är uppdaterade."
							}
						]
					},
					"infobox": "Ange personuppgifter och hemadressar för individer som utövar kontroll över din företagsledning, såsom VD eller styrelsemedlemmar.",
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka",
						"add_person": "+ Lägg till person"
					},
					"messages": {
						"lookup": "Sköter dessa personerna ditt företag? Vänligen ta en titt och bekräfta om det stämmer."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Är din verksamhet ett registrerat företag?",
						"managed": "Är verksamheten ett registrerat företag?"
					},
					"subtitle": {
						"unmanaged": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
						"managed": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna."
					},
					"question": {
						"title": {
							"unmanaged": "Vänligen ange ditt registreringsnummer och din registreringsdomstol",
							"managed": "Ange registreringsnumret och registreringsdomstolen"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Registreringsnummer"
						},
						"registration_court": {
							"label": "Registreringsdomstol",
							"errors": {
								"general": {
									"unmanaged": "Vänligen välj din registreringsdomstol",
									"managed": "Välj registreringsdomstol"
								}
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"documents": {
					"title": "Ladda upp dina dokument",
					"subtitle": "Vi kräver att du skickar ytterligare dokument så att vi kan bekräfta din identitet. Ladda upp endast <strong>JPG</strong>-, <strong>PNG</strong>- eller <strong>PDF</strong>-filer (maximal filstorlek 10 MB).",
					"subheadline": {
						"default": "Eftersom Klarna är en bank med huvudkontor i Sverige och därmed styrs av Svenska Finansinstitutets regler måste Klarna följa EU-direktiven EU 2015/849. Klarna behöver samla in information om människorna som styr företaget så att du kan börja använda Klarnas tjänster. Ladda upp endast <strong>JPG-, PNG- or PDF</strong> -filer (maximal filstorlek 10 MB).",
						"US": "Eftersom Klarna är en bank med huvudkontor i Sverige och därmed styrs av Svenska Finansinstitutets regler måste Klarna följa EU-direktiven EU 2015/849. Klarna är skyldig att samla in information om personerna som styr företaget så att du kan börja använda Klarnas tjänster. Vänligen tillhandahåll följande dokumentation för att vi ska kunna bekräfta din identitet. Ladda upp endast JPG-, PNG- eller PDF-filer (maximal filstorlek 10 MB).",
						"IT": "Eftersom Klarna är en bank med huvudkontor i Sverige och därmed styrs av Svenska Finansinstitutets regler måste Klarna följa EU-direktiven EU 2015/849. Klarna behöver samla in information om personerna som styr företaget så att du kan börja använda Klarnas tjänster. Observera att för att kunna gå vidare med ansökan måste ditt företag vara registrerat hos Handelskammaren. Ladda upp endast JPG-, PNG- eller PDF-filer (maximal filstorlek 10 MB)"
					},
					"header_title": "Dokument",
					"stakeholder": "Intressent",
					"business_documents": "Affärsdokument",
					"browse_files": "Surfa bland filer",
					"optional": "(valfritt)",
					"upload_area": {
						"title": {
							"before_link": "Släpp dina filer här eller",
							"link_text": "Välj filer"
						},
						"description": "{acceptedFileFormats} - Max {maxFileSizeMB} MB/file"
					},
					"description": {
						"APPROVAL": "Ladda upp <strong>godkännande</strong>",
						"CONTRACT": "Ladda upp <strong>avtal</strong>",
						"CORRECTION_NOTE": "Ladda upp <strong>rättelse</strong>",
						"COUNTERSIGNED_CONTRACT": "Ladda upp <strong>kontrasignerat avtal</strong>",
						"ID_DOCUMENT": "Ladda upp <strong>ID</strong> eller <strong>pass</strong>",
						"LICENSE": "Ladda upp <strong>licens</strong>",
						"PROOF_OF_ADDRESS": "Ladda upp <strong>adressbevis</strong>",
						"SPECIAL_AGREEMENT": "Ladda upp <strong>särskilt avtal</strong>",
						"SUPPORTING_DOCUMENT": "Ladda upp <strong>stöddokument</strong>",
						"TAX_OFFICE_REGISTRATION": "Ladda upp <strong>skattekontorets registrering</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Godkännande"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Avtal"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Rättelse"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Kontrasignerat avtal"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Identitetsbevis",
								"IT": "ID-kort"
							},
							"subtitle": {
								"default": "Vänligen gör båda sidorna av ID-kortet synliga.",
								"AT": "Vänligen ge oss båda sidor av ditt ID-kort. Om din adress inte finns på ditt ID behöver vi ytterligare dokumentation, såsom en elräkning, för att verifiera din adress.",
								"AU": "För en snabbare bedömning av din ansökan, vänligen tillhandahåll en giltig kopia av fotolegitimation såsom ett pass eller australiskt körkort för följande personer som är associerade med företaget: Enskild näringsidkare/partnerskap – ägare. Bolaget – det juridiska ombudet, alla styrelseledamöter och alla aktieägare som innehar mer än 25 % av aktierna.",
								"BE": "Vänligen tillhandahåll båda sidor av ID-kortet, se till att bildkvaliteten är tillräcklig och att all information är tydligt läsbar.",
								"DE": "Vänligen ge oss båda sidor av ditt ID-kort. Om din adress inte finns på ditt ID behöver vi ytterligare dokumentation, såsom en elräkning, för att verifiera din adress.",
								"FR": "Vänligen tillhandahåll båda sidor av ID-kortet, se till att bildkvaliteten är tillräcklig och att all information är tydligt läsbar.",
								"GB": "Tillhandahåll ID, om det är ett id-kort, båda sidorna.",
								"IT": "Ett giltigt ID-kort med framsida/baksida för var och en av de personer som anges i ansökan. Körkort, pass, personnummer kan inte godkännas.",
								"NL": "Vänligen tillhandahåll båda sidor av ID-kortet, se till att bildkvaliteten är tillräcklig och att all information är tydligt läsbar.",
								"US": "Körkort eller pass – tillhandahåll båda sidor av id-kortet."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licens"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Adressbevis",
								"BE": "Bevis på hemadress",
								"CZ": "Bevis på hemadress",
								"ES": "Bevis på hemadress",
								"FI": "Bevis på hemadress",
								"FR": "Bevis på hemadress",
								"GR": "Bevis på hemadress",
								"IT": "Bekräftelse av adress",
								"NL": "Bevis på hemadress",
								"PL": "Bevis på hemadress",
								"PT": "Bevis på hemadress"
							},
							"subtitle": {
								"default": "Vi accepterar följande dokument som inte är äldre än tre månader som bevis på hemadress: El-, vatten-, gas-, Wi-Fi-räkningar, skattedeklaration eller hyresavtal. Om du inte har något av dokumenten, ladda upp annat bevis på hemvist och lägg till en anteckning med anledningen.",
								"AU": "För en snabbare bedömning av din ansökan vänligen tillhandahåll ett av följande dokument från de senaste 90 dagarna för att verifiera hemadressen: El-, vatten- eller gasräkning, interneträkning, skattedeklaration eller hyresavtal. *Om du tillhandahåller ett pass som din form av ID, eller om din nuvarande adress inte stämmer överens med adressen på ditt angivna ID, är detta steg obligatoriskt.",
								"BE": "Vi accepterar följande dokument som inte är äldre än tre månader som bevis på hemadress: El-, vatten-, gasräkning, skattedeklaration eller hyresavtal. Om du inte har något av dokumenten, ladda upp annat bevis på hemvist och lägg till en anteckning med anledningen.",
								"FR": "Vi accepterar följande dokument som inte är äldre än tre månader som bevis på hemadress: El-, vatten-, gasräkning, skattedeklaration eller hyresavtal. Om du inte har något av dokumenten, ladda upp annat bevis på hemvist och lägg till en anteckning med anledningen.",
								"NL": "Vi accepterar följande dokument som inte är äldre än tre månader som bevis på hemadress: El-, vatten-, gasräkning, skattedeklaration eller hyresavtal. Om du inte har något av dokumenten, ladda upp annat bevis på hemvist och lägg till en anteckning med anledningen.",
								"US": "Vi accepterar räkningar (gas, vatten, internet, telefon osv.), leasing- eller inteckningshandling med bevis på adress – får inte vara äldre än 90 dagar från ansökningsdatum.",
								"IT": "Om ditt ID-kort har en annan adress än din nuvarande hemadress, behöver vi ett ytterligare dokument för att verifiera din nuvarande hemvist. Vi accepterar följande dokument som inte är äldre än tre månader som bevis på hemadress för de personer som anges i ansökan:"
							},
							"list": {
								"IT": [
									{
										"text": "Hemvistintyg utfärdat online (via SPID) eller av din kommun"
									},
									{
										"text": "El-/vatten-/gas-/Wi-Fi-räkningar"
									},
									{
										"text": "hyresavtal"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Särskilt avtal"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Stöddokument",
								"GB": "Självporträtt"
							},
							"subtitle": {
								"default": null,
								"AU": "Om du säljer märkesvaror av högt värde, vänligen ange två till tre leverantörsfakturor för dessa produkter här. Se till att fakturan innehåller de köpta produkterna, namnet på leverantören, mottagarens namn och leveransadress.",
								"GB": "Tillhandahåll ett självporträttsfoto där du håller ID:t."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Registreringsdokument hos Skatteverket",
								"AT": "Dokument om registrering hos skattemyndigheten",
								"AU": "Pantbrev",
								"BE": "Momsregistreringsnummer aktiverat för gränsöverskridande transaktioner (VIES).",
								"DE": "Dokument om registrering hos skattemyndigheten",
								"FR": "Momsregistreringsnummer aktiverat för gränsöverskridande transaktioner (VIES).",
								"IT": "Momsregistreringsnummer aktiverat för gränsöverskridande transaktioner (VIES).",
								"NL": "Momsregistreringsnummer aktiverat för gränsöverskridande transaktioner (VIES).",
								"NO": "Skattekontorets registrering",
								"US": "EIN-brev"
							},
							"subtitle": {
								"default": null,
								"AT": "Vi godkänner följande dokument som företagsdokument: Handelsregisterutdrag/licens för enskild näringsidkare",
								"AU": "Om ditt ABN är kopplat till en trust, vänligen tillhandahåll en kopia av trustdokumentet, inklusive trustschemat. Observera att detta steg är obligatoriskt för truster.",
								"BE": "Kontrollera att ditt momsregistreringsnummer är aktiverat för gränsöverskridande transaktioner. Eftersom Klarna är en utländsk enhet är detta är nödvändigt även om du bara gör affärer i ditt lokala land. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakta ditt lokala skattekontor för att begära en gratis VIES-aktivering av ditt momsregistreringsnummer.",
								"CZ": "Vi godkänner följande dokument som företagsdokument: Intyg om registrering i det offentliga registret eller utdrag ur handelsregistret för enskild firma.",
								"DE": "Vi godkänner följande dokument som företagsdokument: Handelsregisterutdrag/licens för enskild näringsidkare",
								"ES": "Vi accepterar följande dokument som affärsdokument:  registreringsbevis för registrerade företag, för enskild näringsidkare — Census situation Certificate / Model 036 / Model 037",
								"FI": "Vi godkänner följande dokument som företagsdokument: Registrering för enskilda näringsidkare - folkbokföringsintyg / enligt modell 036 / modell 037",
								"FR": "Kontrollera att ditt momsregistreringsnummer är aktiverat för gränsöverskridande transaktioner. Eftersom Klarna är en utländsk enhet är detta är nödvändigt även om du bara gör affärer i ditt lokala land. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakta ditt lokala skattekontor för att begära en gratis VIES-aktivering av ditt momsregistreringsnummer.",
								"GR": "Vi godkänner följande dokument som företagsdokument: Skattekontorsregistrering / Start av företag / Företagsregistreringsdokument utfärdat av den behöriga tjänsten GEMI (Central Union of Chambers)",
								"IT": "Du kan kontakta Internal Revenue Service (Agenzia delle Entrate) för att begära en gratis VIES-aktivering av ditt momsregistreringsnummer. Detta kommer att vara nödvändigt även om du bara gör affärer i Italien, eftersom Klarna är en utländsk enhet.",
								"NL": "Kontrollera att ditt momsregistreringsnummer är aktiverat för gränsöverskridande transaktioner. Eftersom Klarna är en utländsk enhet är detta är nödvändigt även om du bara gör affärer i ditt lokala land. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakta ditt lokala skattekontor för att begära en gratis VIES-aktivering av ditt momsregistreringsnummer.",
								"NO": "Vi godkänner följande dokument som företagsdokument: Företagsdokument",
								"PL": "Vi godkänner följande dokument som företagsdokument: Intyg om registrering i CEIDG:s företagsregister, utdrag ur National Court Register (KRS)",
								"PT": "Vi godkänner följande dokument som affärsdokument:  Certidão Permanente (obligatoriskt), registreringsbevis för aktiebolag. För enskild näringsidkare, registering som egenföretagare (Declaração de Início de Atividade).",
								"US": "Detta är brevet från IRS som tilldelar dig ett EIN-nummer (IRS CP575 EIN Letter). Om ditt företag är en enskild firma och du ansöker med ditt SSN, vänligen tillhandahåll en kopia av ditt SSN-kort istället"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Certifierad identitetshandling"
							},
							"subtitle": {
								"default": "Vi godkänner följande dokument: ID-kort, pass, körkort. Dokumenten måste uppfylla följande kriterier:"
							},
							"list": [
								{
									"text": "Certifierad av en auktoriserad certifieringstjänsteman (till exempel en notarie, edskommissionär, jurist, advokat och/eller auktoriserad revisor)."
								},
								{
									"text": "Signerad och stämplad. Stämpeln måste visa synliga och verifierbara uppgifter om intygsgivaren, såsom fullständigt namn, adress och i tillämpliga fall registreringsnummer."
								},
								{
									"text": "Daterad – certifieringsdatum som inte är äldre än sex månader."
								},
								{
									"text": "Bestyrkt som en sann kopia av ett original genom att tydligt ange att originalhandlingen sågs."
								}
							]
						}
					},
					"modal": {
						"title": "Varför behöver vi dina dokument?",
						"close": "Stäng",
						"content": [
							{
								"title": "Beskrivning av processen",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Filkrav",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Hur skannar man dokument?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Uppladdningen misslyckades",
						"too_large_file": "Filen är för stor <strong>(max {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Du kan endast ladda upp {number} filer.",
						"invalid_file_format": "Ogiltigt filformat. De enda godkända filtyperna är {acceptedFileFormats}",
						"duplicate_file_name": "Dubbelt filnamn. Alla uppladdningar måste ha unika namn.",
						"try_again": "Försök igen eller <u>välj en annan fil</u>"
					},
					"buttons": {
						"modal": "Varför behöver vi dina dokument?",
						"next": "Nästa",
						"back": "Tillbaka",
						"submit": "Skicka in dokument"
					}
				},
				"document_upload_success": {
					"title": "Uppladdningen klar.",
					"message": "Tack! Dina dokument har laddats upp"
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Kan du vänligen ange ditt registreringsnummer?",
							"AT": "Kan du vänligen ange ditt registreringsnummer?",
							"CA": "Kan du ange ditt federala företagsnummer?",
							"GR": "Vänligen ange ditt G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Kan du vänligen ange ditt företagsnummer?"
						},
						"managed": {
							"default": "Kan du vänligen ange företagets registreringsnummer?",
							"AT": "Kan du vänligen ange företagets registreringsnummer?",
							"CA": "Kan du ange ditt federala företagsnummer?",
							"GR": "Vänligen ange företagets G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Kan du vänligen ange verksamhetens företagsnummer?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
							"AT": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
							"CA": "Vi behöver det federala företagsnummer som tilldelat ditt företag av CRA (Canada Revenue Agency) för att verifiera dina företagsuppgifter.",
							"GR": "Vi behöver ditt G.E.MI.-nummer för att verifiera företagsuppgifterna.",
							"NZ": "Vi behöver ditt företagsnummer för att verifiera dina uppgifter."
						},
						"managed": {
							"default": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna.",
							"AT": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna.",
							"CA": "Vi behöver det federala företagsnummer som tilldelat ditt företag av CRA (Canada Revenue Agency) för att verifiera dina företagsuppgifter.",
							"GR": "Vi behöver G.E.MI.-numret för att verifiera företagsuppgifterna.",
							"NZ": "Vi behöver verksamhetens företagsnummer för att verifiera företagsuppgifterna."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Observera att Klarna för närvarande inte tillhandahåller sina betalningstjänster för kanadensiska enmansföretag. Om du fortsätter med din ansökan så kommer den att få avslag."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer",
								"CA": "Företagsnummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
								"NZ": "Företagsnummer"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Vad är din skatteklassificering?",
						"managed": "Kan du vänligen ange företagets bolagsform?"
					},
					"subtitle": {
						"unmanaged": "Vi ber dig om olika information beroende på företagets juridiska status.",
						"managed": "Vi ber dig om olika information beroende på företagets juridiska status."
					},
					"info": {
						"unmanaged": "Du hittar ditt företags arbetsgivarnummer (EIN) på deklarationer, kreditrapporter, lönepapper eller licenser och tillstånd",
						"managed": "Du hittar företagets arbetsgivarnummer (EIN) på deklarationer, kreditrapporter, lönepapper eller licenser och tillstånd"
					},
					"fields": {
						"registration_number": {
							"label": "Arbetsgivarnummer",
							"errors": {
								"general": "Ange ett gilitigt arbetsgivarnummer",
								"invalid": "Arbetsgivarnummer ska vara 9 siffror långt med ett \"-\" efter de första två, t. ex. 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Klassificering för federal skatt",
								"managed": "Verksamhetstyp"
							},
							"errors": {
								"is_one_of": "Vänligen välj en av företagstyperna i listan"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Kan du vänligen ange ditt momsregistreringsnummer?",
							"AU": "Kan du vänligen ange ditt australiska organisationsnummer?",
							"ES": "Vad är ditt skatteregistreringsnummer?",
							"NZ": "Kan du vänligen ange ditt GST-nummer?"
						},
						"managed": {
							"default": "Kan du vänligen ange momsregistreringsnumret?",
							"AU": "Kan du vänligen ange ABN-numret?",
							"ES": "Vad är ditt skatteregistreringsnummer?",
							"NZ": "Kan du vänligen ange GST-numret?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Det är enklare för oss att verifiera dina företagsuppgifter om vi har ditt momsregistreringsnummer.",
							"AU": "Det är enklare för oss att verifiera dina företagsuppgifter med hjälp av ditt australiska organisationsnummer.",
							"NZ": "Det är enklare för oss att verifiera dina företagsuppgifter om vi har ditt GST-nummer.",
							"ES": "Med ditt företags NIF-, NIE- eller DNI-nummer är det enklare för oss att verifiera dina företagsuppgifter."
						},
						"managed": {
							"default": "Vi använder momsregistreringsnumret för att verifiera företagsuppgifterna.",
							"AU": "Vi använder ABN-numret för att verifiera företagsuppgifterna.",
							"NZ": "Vi använder GST-numret för att verifiera företagsuppgifterna.",
							"ES": "Vi använder NIF-, NIE- eller DNI-numret för att verifiera företagsuppgifterna."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Momsregistreringsnummer",
								"AU": "Australiskt organisationsnummer",
								"NZ": "GST-nummer",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Vilket typ av företag har du?",
						"managed": "Vilken typ av verksamhet driver företaget?"
					},
					"subtitle": {
						"unmanaged": "Vi är skyldiga att ställa vissa frågor baserat på din företagstyp.",
						"managed": "Vi är skyldiga att ställa några frågor baserade på verksamhetstypen."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Juridisk företagstyp",
							"errors": {
								"is_one_of": "Vänligen välj en av företagstyperna i listan"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Är din verksamhet ett registrerat företag?",
							"AU": "Har din verksamhet ett ACN?",
							"ES": "Finns ditt företag med i Registro Mercantil?"
						},
						"managed": {
							"default": "Är verksamheten ett registrerat företag?",
							"AU": "Har verksamheten ett ACN?",
							"ES": "Finns ditt företag med i Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
							"AT": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
							"AU": "Vänligen ange ditt ACN om du har ett. Annars väljer du nej.",
							"ES": "Svara Ja om du är en SL, SA, SCP, ...osv. Svara nej om du är en autónomo, frilansare, ...osv.",
							"GB": "Vi behöver ditt företags organisationsnummer för att verifiera dina uppgifter.",
							"GR": "Vi behöver ditt G.E.MI.-nummer för att verifiera företagsuppgifterna."
						},
						"managed": {
							"default": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna.",
							"AT": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna.",
							"AU": "Vänligen ange ACN om företaget har ett. Annars väljer du nej.",
							"ES": "Svara Ja om du är en SL, SA, SCP, ...osv. Svara nej om du är en autónomo, frilansare, ...osv.",
							"GB": "Vi behöver företagets organisationsnummer för att verifiera företagsuppgifterna.",
							"GR": "Vi behöver företagets G.E.MI.-nummer för att verifiera företagsuppgifterna."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vänligen ange ditt registreringsnummer",
							"AT": "Vänligen ange ditt registreringsnummer",
							"AU": "Vänligen ange ditt ACN",
							"ES": "Ange ditt företags NIF/NIE/DNI",
							"GB": "Vänligen ange ditt organisationsnummer",
							"GR": "Vänligen ange ditt G.E.MI.-nummer (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Ange registreringsnumret",
							"AT": "Ange registreringsnumret",
							"AU": "Vänligen ange ACN",
							"ES": "Ange ditt företags NIF/NIE/DNI",
							"GB": "Ange organisationsnumret",
							"GR": "Vänligen ange G.E.MI.-numret (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer",
								"AU": "Australian Company Number (ACN)",
								"ES": "Företagets NIF/NIE/DNI",
								"GB": "Organisationsnummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"mid-selector": {
					"title": "Välj en butik",
					"subtitle": "Den här e-postadressen är ansluten till flera butiker. Välj en butik för att fortsätta.",
					"mid-selector": "Merchant ID/Butiksnamn",
					"buttons": {
						"next": "Fortsätt"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Är din verksamhet ett registrerat företag?",
						"managed": "Är verksamheten ett registrerat företag?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter.",
							"AT": "Vi behöver ditt företags registreringsnummer för att verifiera dina uppgifter."
						},
						"managed": {
							"default": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna.",
							"AT": "Vi behöver företagets registreringsnummer för att verifiera företagsuppgifterna."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vänligen ange ditt registreringsnummer",
							"AT": "Vänligen ange ditt registreringsnummer"
						},
						"managed": {
							"default": "Ange registreringsnumret",
							"AT": "Ange registreringsnumret"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Är ditt företag momsregistrerat?",
							"ES": "Har ditt företag ett NIF/NIE/DNI?",
							"NZ": "Är ditt företag registrerat för GST?"
						},
						"managed": {
							"default": "Är verksamheten registrerad för moms?",
							"ES": "Har ditt företag ett NIF/NIE/DNI?",
							"NZ": "Är detta företag registrerat för GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Det är enklare för oss att verifiera dina företagsuppgifter om du har ett momsregistreringsnummer.",
							"ES": "Om ditt företag har ett NIF-, NIE- eller DNI-nummer är det enklare för oss att verifiera dina företagsuppgifter.",
							"NZ": "Om du har ett GST-nummer, kan vi enklare verifiera dina företagsuppgifter."
						},
						"managed": {
							"default": "Vi använder momsregistreringsnumret för att verifiera företagsuppgifterna.",
							"ES": "Om ditt företag har ett NIF-, NIE- eller DNI-nummer är det enklare för oss att verifiera dina företagsuppgifter.",
							"NZ": "Vi använder GST-numret för att verifiera företagsuppgifterna."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vänligen ange ditt momsregistreringsnummer",
							"ES": "Ange ditt företags NIF/NIE/DNI",
							"NZ": "Ange ditt GST-nummer"
						},
						"managed": {
							"default": "Ange momsregistreringsnumret",
							"ES": "Ange ditt företags NIF/NIE/DNI",
							"NZ": "Ange ditt GST-nummer"
						}
					},
					"vat_id": {
						"label": {
							"default": "Momsregistreringsnummer",
							"ES": "Företagets NIF/NIE/DNI",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Är ditt företag momsregistrerat?",
						"managed": "Är verksamheten registrerad för moms?"
					},
					"subtitle": {
						"unmanaged": "Det är enklare för oss att verifiera dina företagsuppgifter om du har ett momsregistreringsnummer.",
						"managed": "Vi använder momsregistreringsnumret för att verifiera företagsuppgifterna."
					},
					"form_title": {
						"unmanaged": "Vänligen ange ditt momsregistreringsnummer",
						"managed": "Ange momsregistreringsnumret"
					},
					"vat_id": {
						"label": {
							"default": "Momsregistreringsnummer",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Vad är din företagsadress?",
						"managed": "Vad är företagets verksamhetsadress?"
					},
					"subtitle": {
						"unmanaged": "Vi behöver veta var din verksamhet är belägen.",
						"managed": "Vi behöver veta var verksamheten ligger."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"fields": {
						"partnership_name": {
							"label": "Partnerskapsnamn",
							"errors": {
								"general": "Vänligen ange ett partnerskapsnamn"
							}
						},
						"street": {
							"label": "Adress",
							"errors": {
								"general": "Vänligen ange en giltig adress"
							}
						},
						"postal_code": {
							"label": "Postkod",
							"errors": {
								"general": "Vänligen ange en giltig postkod"
							}
						},
						"city": {
							"label": "Stad",
							"errors": {
								"general": "Vänligen ange en giltig stad"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Vänligen ange ett giltigt land"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Vem äger företaget?",
						"GB": "Vem leder företaget?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi är juridiskt skyldiga enligt EU:s lagstiftning om penningtvätt ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						],
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						]
					},
					"infobox": "Ange personuppgifter och hemadressar för alla partners och huvudmän som utövar kontroll över din företagsledning.",
					"buttons": {
						"add_person": "+ Lägg till person",
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"payouts_summary": {
					"title": "Bankkonton",
					"default_bank_accounts": {
						"no_elements": "Inget standardkonto tillgängligt"
					},
					"additional_bank_accounts": {
						"no_elements": "Du angav inga ytterligare bankkonton"
					}
				},
				"pre_assessment_company_details": {
					"title": "Fyll i mer uppgifter om möjligheten.",
					"subtitle": "Ange del av kortvolym och företagsinformation för den här handlaren. Indikera också om företaget verkar i från andra marknader än registreringslandet då detta krävs för riskbedömning.",
					"fields": {
						"volume_by_card": {
							"label": "Kortvolyms del av total volym (%)",
							"errors": {
								"invalid": "Kortvolym ska vara ett nummer mellan 0 och 100",
								"invalid_hint": "Lägg till andelen korttransaktioner från den totala Klarna-volymen för den här möjligheten. Ange 0 % om din möjlighet inte har några kortbetalningar "
							}
						},
						"average_order_value": {
							"label": "Genomsnittligt ordervärde (i SEK)",
							"tooltip": "Måste vara ett positivt belopp i SEK",
							"errors": {
								"invalid": "Måste vara ett positivt belopp i SEK"
							}
						},
						"registration_country": {
							"label": "Registreringsland",
							"errors": {
								"required": "Registreringsland måste fyllas i"
							}
						},
						"operating_country": {
							"label": "Verksamhetsland",
							"errors": {
								"required": "Verksamhetsland måste fyllas i"
							}
						},
						"registration_number": {
							"label": {
								"default": "Registreringsnummer (krävs för registrerade företag)",
								"AU": "ACN (krävs för registrerade företag)",
								"ES": "Företags NIF/NIE/DNI (krävs för registrerade företag)",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.) (krävs för registrerade företag)",
								"NZ": "Företagsnummer (krävs för registrerade företag)",
								"US": "TIN/EIN (krävs för registrerade företag)"
							}
						},
						"vat_number": {
							"label": "Australiskt organisationsnummer",
							"errors": {
								"required": "Ange ACN- eller ABN-nummer",
								"invalid": "ABN-numret ska vara 11 siffror långt"
							}
						},
						"registration_authority": {
							"label": "Registreringsmyndighet",
							"errors": {
								"required": "Vänligen välj din registreringsmyndighet"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "Säljrepresentants e-post",
							"errors": {
								"invalid": "Vänligen ange en giltig e-postadress"
							}
						},
						"store_url": {
							"label": "Butiks-URL",
							"errors": {
								"required": "Butiks-URL måste fyllas i",
								"invalid": "Vänligen ange en giltig webbadress"
							}
						},
						"goods_category": {
							"label": "Största varukategori till försäljning",
							"errors": {
								"invalid": "Du måste välja ett av alternativen"
							}
						},
						"is_managed": {
							"label": "Lanseras hanterad post?"
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"pre_assessment_products": {
					"title": "Vänligen lista alla produkter",
					"subtitle": "Alla produkter per försäljningsland krävs för riskbedömningen",
					"select": {
						"label": "Sök produkt"
					},
					"selected": {
						"label": "Valda produkter:"
					},
					"clear": "Rensa alla",
					"errors": {
						"invalid": "Minst en produkt per land ska vara vald"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "I butik",
						"TELESALES": "Telefonförsäljning",
						"SELLER_APP": "Säljare-appen"
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"wrong_prefill_data": {
					"title": "Ogiltig data angedd",
					"subtitle": "Ogiltig eller inkompatibel förfylld information tillhandahållen av SalesForce.",
					"details": "Uppgifter:",
					"fields": {
						"goodsCategory": "Varukategori",
						"paymentInterval": "Betalningsintervall",
						"paymentDelay": "Betalningsfördröjning",
						"registrationCountry": "Registreringsland",
						"storeUrl": "Butiks-URL",
						"mainSellingCountry": "Huvudsakligt försäljningsland",
						"products": "Produkter",
						"products_item": "Produkt {index}",
						"products_item_yearlyAcquiredVolume": "Produkt {index} årsvolym",
						"products_item_sellingCountry": "Produkt {index} försäljningsland",
						"products_item_productName": "Produkt {index} namn",
						"products_item_channels": "Produkt {index} kanaler",
						"products_item_channels_item": "Produkt {index} kanal"
					},
					"error_types": {
						"fallback": "är ogiltig",
						"any": {
							"required": "krävs och tillhandahölls ej"
						}
					}
				},
				"selling_countries": {
					"title": "Vänligen lista alla försäljningsländer",
					"subtitle": "En komplett lista med länder krävs för riskbedömningen",
					"select": {
						"label": "Sök land"
					},
					"selected": {
						"label": "Valda länder:"
					},
					"fields": {
						"selling_countries": {
							"label": "Välj land",
							"errors": {
								"invalid": "Du måste välja minst ett land"
							}
						}
					},
					"clear": "Rensa alla",
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"main_selling_country": {
					"title": "Vilken är den huvudsakliga Klarna-marknaden för handlaren?",
					"subtitle": "Vänligen välj marknaden där Klarna-volymen förväntas vara högst",
					"errors": {
						"invalid": "Du måste välja ett land"
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"fca_number": {
					"title": "Vänligen ange FCA-numret",
					"subtitle": "Vi är juridiskt skyldiga att verifiera kreditmäklarlicensen.",
					"fields": {
						"fca_number": {
							"label": "FCA-nummer",
							"errors": {
								"general": "Ange ett giltigt FCA-nummer"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"sole_trader": {
					"title": "Vem äger företaget?",
					"subtitle": {
						"default": [
							{
								"text": "Vi är juridiskt skyldiga enligt EU:s lagstiftning om penningtvätt ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						]
					},
					"infobox": {
						"unmanaged": "Ange dina personuppgifter och din hemadress.",
						"managed": "Ange ägarens personuppgifter och hemadress."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Personen som gör ansökan är densamma som den enskilda näringsidkaren.",
							"error": "Tyvärr, men du kan bara fortsätta om du som den enskilda näringsidkaren gör denna ansökan."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Bedrivs verksamheten från en annan adress?",
								"managed": "Bedriver företaget sin verksamhet från en annan adress?"
							},
							"subtitle": {
								"unmanaged": "Välj bara Ja om du bedriver ditt företag från en annan adress än den där du bor.",
								"managed": "Välj bara Ja om företaget bedriver sin verksamhet från en annan adress än ensamföretagarens bostadsadress."
							}
						},
						"title": "Vänligen ange företagsadressen",
						"fields": {
							"street": {
								"label": "Adress",
								"errors": {
									"general": "Vänligen ange en giltig adress"
								}
							},
							"postal_code": {
								"label": "Postkod",
								"errors": {
									"general": "Vänligen ange en giltig postkod"
								}
							},
							"city": {
								"label": "Stad",
								"errors": {
									"general": "Vänligen ange en giltig stad"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vänligen ange ett giltigt land"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Kan du vänligen bekräfta två saker till?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Du är den enskilda näringsidkaren",
							"label": "Personen som gör ansökan är densamma som den enskilda näringsidkaren."
						},
						"are_you_the_only_with_financial_control": {
							"title": "Du är den enda med ekonomisk kontroll",
							"label": "Ägaren är den enda personen med ekonomisk kontroll över ditt företags bankkonto(n)"
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"robot_message": "Tyvärr, men vi måste bekräfta de här två sakerna"
				},
				"underwriting_info": {
					"title": "Vänligen ange möjlighetens volym och betalningsfördröjning",
					"subtitle": "Vänligen lista den förväntade årliga Klarna-volymen för denhär möjligheten för alla marknader och betalningsfördröjningen. Om betalningsfördröjningen skiljer sig åt mellan länder, använd fördröjningen för det huvudsakliga försäljningslandet som valts.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Total årlig marknadsvolym (i SEK)",
							"errors": {
								"invalid": "Den totala årliga marknadsvolymen ska vara ett positivt belopp i SEK",
								"too_long": "Den totala årliga marknadsvolymen kan inte ha mer än 16 siffror"
							}
						},
						"payment_delay": {
							"label": "Betalningsfördröjning",
							"errors": {
								"general": "Vänligen ange ett betalningsfördröjningsvärde",
								"invalid": "Betalningsfördröjning ska vara ett nummer mellan {min} och {max}"
							}
						},
						"payment_interval": {
							"label": "Betalningsintervall",
							"errors": {
								"invalid": "Du måste välja ett av alternativen"
							}
						},
						"volume_by_card": {
							"label": "Del av betalning (%)",
							"errors": {
								"invalid": "Del av betalning ska vara ett nummer mellan 0 och 100",
								"invalid_hint": "Lägg till andelen korttransaktioner från den totala Klarna-volymen för den här möjligheten. Ange 0 % om din möjlighet inte har några kortbetalningar "
							}
						},
						"average_order_value": {
							"label": "Genomsnittligt ordervärde (i SEK)"
						}
					},
					"buttons": {
						"back": "Tillbaka",
						"next": "Nästa"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Vad är dina butiksuppgifter?"
						},
						"managed": "Vad är butiksuppgifterna?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Vi använder den här informationen för att ställa in ditt företagskonto.",
							"default": "Vi kommer använda de angivna uppgifterna som dina primära kontaktuppgifter och för att ta en titt på din butik."
						},
						"managed": "Vi kommer att använda uppgifterna som kontaktinformation för konsumenter och för att ta en titt på butiken."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Varumärkesnamn/Bifirma",
								"MX": "Varumärkesnamn/Bifirma",
								"US": "Varumärkesnamn/Bifirma",
								"default": "Butiksnamn"
							},
							"errors": {
								"required": "Butiksnamn måste fyllas i",
								"required_us": "Varumärkesnamn/Bifirma måste fyllas i",
								"invalid": "Ange ett butiksnamn med minst 2 tecken",
								"invalid_us": "Ange ett varumärkesnamn/DBA med minst 2 tecken",
								"invalid_characters": "Butiksnamnet får inte innehålla följande tecken: < >",
								"invalid_characters_us": "Varumärkets namn / DBA får inte innehålla följande tecken: < >"
							}
						},
						"website": {
							"label": "Webbsida för onlinebutik",
							"errors": {
								"required": "Webbsida måste fyllas i",
								"invalid": "Vänligen ange en giltig webbadress"
							}
						},
						"goods_category": {
							"label": "Största varukategori till försäljning",
							"errors": {
								"required": "Varukategori måste fyllas i"
							}
						},
						"email": {
							"label": "E-postadress till kundservice",
							"errors": {
								"required": "Företagsägares e-postadress måste fyllas i",
								"invalid": "Vänligen ange en giltig e-postadress"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Ändra produkter"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Vad är din registrerade företagsadress?",
						"managed": "Vad är företagets registrerade verksamhetsadress?"
					},
					"subtitle": {
						"unmanaged": "Vi behöver veta på vilken adress ditt företag är registrerat.",
						"managed": "Vi behöver veta på vilken adress verksamheten är registrerad."
					},
					"question": {
						"title": {
							"unmanaged": "Bedrivs verksamheten från en annan adress?",
							"managed": "Bedriver företaget sin verksamhet från en annan adress?"
						},
						"subtitle": {
							"unmanaged": "Välj bara Ja om du bedriver ditt företag från en annan adress än den där det är registrerat.",
							"managed": "Välj bara Ja om företaget bedriver sin verksamhet från en annan adress än den registrerade verksamhetsadressen."
						}
					},
					"toggle": {
						"title": "Lägg till adressen till huvudkontoret"
					},
					"fields": {
						"company_name": {
							"label": "Juridiskt företagsnamn",
							"errors": {
								"general": "Vänligen ange ett företagsnamn"
							}
						},
						"street": {
							"label": "Adress",
							"errors": {
								"general": "Vänligen ange en adress"
							}
						},
						"postal_code": {
							"label": "Postnummer",
							"errors": {
								"general": "Vänligen ange ett postnummer"
							}
						},
						"city": {
							"label": "Stad",
							"errors": {
								"general": "Vänligen ange en stad"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Vänligen ange ett land"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"messages": {
						"lookup": "Är detta ditt företag? Vänligen ta en titt och bekräfta om det stämmer."
					}
				},
				"uk_sole_trader": {
					"title": "Vem äger det här företaget?",
					"subtitle": {
						"unmanaged": "Du är på väg att ingå ett avtal med Klarna. Vi behöver därför samla in din personliga information.",
						"managed": "Vi är skyldiga att samla in och verifiera ägarens personuppgifter."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Bedrivs verksamheten från en annan adress?",
								"managed": "Bedriver företaget sin verksamhet från en annan adress?"
							},
							"subtitle": {
								"unmanaged": "Välj bara Ja om du bedriver ditt företag från en annan adress än den där du bor.",
								"managed": "Välj bara Ja om företaget bedriver sin verksamhet från en annan adress än ensamföretagarens bostadsadress."
							}
						},
						"title": "Vänligen ange företagsadressen",
						"fields": {
							"street": {
								"label": "Adress",
								"errors": {
									"general": "Vänligen ange en giltig adress"
								}
							},
							"postal_code": {
								"label": "Postkod",
								"errors": {
									"general": "Vänligen ange en giltig postkod"
								}
							},
							"city": {
								"label": "Stad",
								"errors": {
									"general": "Vänligen ange en giltig stad"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vänligen ange ett giltigt land"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Vem äger företaget?",
					"subtitle": {
						"default": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
					},
					"infobox": {
						"unmanaged": "Ange dina personuppgifter och din hemadress.",
						"managed": "Ange ägarens personuppgifter och hemadress."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Bedrivs verksamheten från en annan adress?",
								"managed": "Bedriver företaget sin verksamhet från en annan adress?"
							},
							"subtitle": {
								"unmanaged": "Välj bara Ja om du bedriver ditt företag från en annan adress än den där du bor.",
								"managed": "Välj bara Ja om företaget bedriver sin verksamhet från en annan adress än ensamföretagarens bostadsadress."
							}
						},
						"title": "Vänligen ange företagsadressen",
						"fields": {
							"street": {
								"label": "Adress",
								"errors": {
									"general": "Vänligen ange en giltig adress"
								}
							},
							"postal_code": {
								"label": "Postkod",
								"errors": {
									"general": "Vänligen ange en giltig postkod"
								}
							},
							"city": {
								"label": "Stad",
								"errors": {
									"general": "Vänligen ange en giltig stad"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vänligen ange ett giltigt land"
								}
							},
							"region": {
								"label": "Stat",
								"errors": {
									"general": "Vänligen ange en stat"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Finns det någon som äger mer än 25 % av företaget?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"default": [
							{
								"text": "Vi behöver veta alla personer som äger mer än 25 % av aktierna eller rösträtten i företaget eller som utövar liknande kontroll. Vi är juridiskt skyldiga att samla in denna information enligt EU:s penningtvättsdirektiv ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						]
					},
					"infobox": {
						"default": "Ange varje individs personuppgifter och hemadress.",
						"AU": "Ange varje individs personuppgifter och hemadress. Detta måste vara en fysisk person för företag med komplexa ägarstrukturer."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka",
						"add_person": "+ Lägg till person"
					},
					"messages": {
						"lookup": "Äger dessa personer mer än 25 % av ditt företag? Vänligen ta en titt och bekräfta om det stämmer."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Vad är din företagsadress?",
						"managed": "Vad är företagets registrerade verksamhetsadress?"
					},
					"subtitle": {
						"unmanaged": "Detta är platsen där ditt företag är registrerat och kommer att visas på dina Klarnafakturor.",
						"managed": "Vi behöver veta på vilken adress verksamheten är registrerad."
					},
					"question": {
						"title": {
							"unmanaged": "Bedrivs verksamheten från en annan adress?",
							"managed": "Bedriver företaget sin verksamhet från en annan adress?"
						},
						"subtitle": {
							"unmanaged": "Välj bara Ja om du bedriver ditt företag från en annan adress än den där det är registrerat.",
							"managed": "Välj bara Ja om företaget bedriver sin verksamhet från en annan adress än den registrerade verksamhetsadressen."
						}
					},
					"toggle": {
						"title": "Lägg till adressen till huvudkontoret"
					},
					"fields": {
						"company_name": {
							"label": "Registrerat företagsnamn",
							"errors": {
								"general": "Vänligen ange ett företagsnamn"
							}
						},
						"street": {
							"label": "Adress",
							"errors": {
								"general": "Vänligen ange en adress"
							}
						},
						"postal_code": {
							"label": "Postnummer",
							"errors": {
								"general": "Vänligen ange ett postnummer"
							}
						},
						"city": {
							"label": "Stad",
							"errors": {
								"general": "Vänligen ange en stad"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Vänligen ange ett land"
							}
						},
						"state_of_incorporation": {
							"label": "Registreringsstat",
							"errors": {
								"general": "Vänligen ange en registreringsstat"
							}
						},
						"state": {
							"label": "Stat",
							"errors": {
								"general": "Vänligen ange en stat"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Puerto Rico är inte tillåtet"
							}
						}
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"select_products": {
					"title": "Våra tjänster",
					"title_kco_hidden": "Betalningsmetoder som ökar försäljningen.",
					"subtitle": "Välj de tjänster du är intresserad av.",
					"subtitle_kco_hidden": "Lås upp dina kunders köpkraft. Erbjud fler betalningsalternativ så att de kan välja när och hur de ska betala.",
					"platform_alert": null,
					"buttons": {
						"next": "Nästa"
					}
				},
				"signup_products": {
					"title_line_1": "Klarnaprodukter för din butik",
					"title_kco_hidden_line_1": "Betalningsmetoder som",
					"title_kco_hidden_line_2": "ökar försäljningen.",
					"subtitle": "När du erbjuder Klarnas betalningsmetoder får du en genomsnittlig ökning på 30 % i konverteringar, 41 % i genomsnittligt ordervärde och 36 % i köpfrekvens.",
					"subtitle_kco_hidden": "Lås upp dina kunders köpkraft. Erbjud fler betalningsalternativ så att de kan välja när och hur de ska betala.",
					"info_block": "Visar tillgängliga produkter för",
					"special_offer": "Specialerbjudande: {percentageFee} % + {fixedFee} per transaktion. Giltigt till och med {validUntil}.",
					"buttons": {
						"contact_sales": "Kontakta säljteam",
						"next": "Skapa konto",
						"back": "Tillbaka"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Tillbaka",
						"next": "Nästa"
					}
				},
				"business_concepts": {
					"title": "Vänligen välj applicerbara affärskoncept.",
					"subtitle": "Välj bara de som är applicerbara. Detta kan vara mer än ett alternativ.",
					"errors": {
						"select_at_least_one": "Vänligen välj minst ett affärskoncept."
					},
					"buttons": {
						"next": "Nästa",
						"back": "Tillbaka"
					}
				},
				"confirm_copy": {
					"title": "Bekräfta kopiering",
					"disclaimer": "Existerande information för aktuellt MID skrivs över med data från",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Kopiera inte",
						"confirmCopy": "Kopiera data"
					}
				},
				"pre_assessment_summary": {
					"title": "Sammanfattning ",
					"subtitle": "Vänligen granska uppgifterna noggrant innan du skickar in dem för försäkran",
					"banner": {
						"mcc_deal": "Detta är ett MCC-avtal. Följ upptrappningsrutinen för MCC/ECC"
					},
					"selling_countries": {
						"title": "Vänligen välj marknaden där volymen förväntas vara högst.",
						"main_selling_country": "Huvudsakligt försäljningsland"
					},
					"pre_assessment_products": {
						"title": "Produkter"
					},
					"company_details": {
						"title": "Företagsuppgifter"
					},
					"fca_number": {
						"title": "FCA-nummer"
					},
					"high_exposure_questionnaires": {
						"title": "Frågeformulär med hög exponering"
					},
					"mia_questionnaires": {
						"title": "MIA-frågeformulär"
					},
					"buttons": {
						"back": "Tillbaka",
						"edit": "Ändra",
						"submit": "Skicka"
					}
				},
				"pre_assessment_overview": {
					"title": "Översikt över förhandsbedömning",
					"subtitle_APPROVED": "Vänligen se de godkända villkoren för den här möjligheten nedan.",
					"subtitle_REJECTED": "Vänligen se de avslagna villkoren för den här möjligheten nedan.",
					"subtitle_UNRESOLVED": "Du kan ändra den inskickade informationen om du upptäcker några fel. Detta skapar inte ett nytt ärende.",
					"status": {
						"APPROVED": "Ärendet godkändes",
						"REJECTED": "Ärendet avslogs",
						"UNRESOLVED": "Väntar på granskningsbeslut...",
						"UNRESOLVED_TIMED_OUT": "Det här ärendet kommer att granskas manuellt. Observera att detta kan ta flera dagar.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Se ärende i Merchant Review GUI",
						"STARTED": "Ärendet skickats in för granskning"
					},
					"buttons": {
						"change": "Ändra",
						"new_case": "Nytt ärende"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hej!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Klarna står under Finansinspektionens tillsyn och måste därmed förhindra penningtvätt i enlighet med EU:s penningtvättsdirektiv EU 2015/849 (med ändringar eller ersatt). För dig som kund, innebär det att Klarna måste samla in information om de personer som kontrollerar företaget (s.k. verkliga huvudmän) innan du kan börja använda våra tjänster. Befintliga kunder ska regelbundet uppdatera sådan information för att se till att den hålls aktuell. Mer information kan du finna i "
							},
							{
								"text": "EU-direktivet",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Nästa"
					}
				},
				"recollection_confirmation": {
					"title": "Bekräftelse",
					"subtitle": "Vänligen granska uppgifterna noggrant innan du skickar in dem för försäkran",
					"stakeholder": "Intressent {index}",
					"buttons": {
						"back": "Tillbaka",
						"submit": "Skicka"
					}
				},
				"recollection_overview": {
					"title": "Tack!",
					"subtitle": "Här är en översikt på den information du skickade in.",
					"stakeholder": "Intressent {index}",
					"notice": "Din information har blivit mottagen."
				},
				"volume_separation": {
					"title_line_1": "Vad är ditt onlineföretags storlek?",
					"subtitle": "Klarna har den bästa lösningen för ditt företag — oavsett storlek.",
					"selector_title": "Årlig omsättning",
					"below": "Under {threshold}",
					"between": "Mellan {belowThreshold} och {aboveThreshold}",
					"over": "Över {threshold}",
					"buttons": {
						"back": "Tillbaka"
					}
				},
				"basic_info": {
					"title_line_1": "Kom igång",
					"title_line_2": "med Klarna.",
					"subtitle": "Vi behöver lite information så att du hamnar rätt.",
					"fields": {
						"email": {
							"label": "Företagets e-post",
							"field_link": "Inte ett företag?",
							"errors": {
								"required": "Mailadress måste fyllas i",
								"invalid": "Vänligen ange en giltig mailadress"
							}
						},
						"email_confirmation": {
							"label": "Bekräfta företagets e-post",
							"tooltip": "Din företagsmail kommer att vara ett huvudsätt för kommunikation med Klarna. Försäkra att det är korrekt",
							"errors": {
								"required": "E-postadress för bekräftelse krävs",
								"invalid": "Se till att du har angett samma e-postadress två gånger"
							}
						},
						"website": {
							"label": "URL för e-handelsbutik",
							"errors": {
								"required": "URL för e-handelsbutik måste fyllas i",
								"invalid": "Vänligen ange en giltig URL"
							}
						},
						"country": {
							"label": "Land för registrering",
							"errors": {
								"general": "Vänligen välj ett av länderna i listan"
							}
						}
					},
					"buttons": {
						"continue": "Fortsätt"
					}
				},
				"contact_details": {
					"title_line_1": "Prata med vårt team.",
					"subtitle": "Fyll i den här formen så hör vi av oss med skräddarsydda lösningar för ditt företag.",
					"fields": {
						"full_name": {
							"label": "Fullständigt namn",
							"errors": {
								"required": "Komplett namn måste fyllas i"
							}
						},
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Du måste inkludera landskoden, t.ex. +46 8 123 456",
							"errors": {
								"required": "Telefonnummer måste fyllas i",
								"invalid": "Ogiltigt telefonnummer"
							}
						},
						"tell_us_more": {
							"label": "Berätta lite mer om din verksamhet (frivilligt)"
						}
					},
					"buttons": {
						"back": "Tillbaka",
						"submit": "Skicka in kontaktuppgifter"
					}
				},
				"contact_received": {
					"title": "Vi hörs snart!",
					"message_1": "Vårt säljteam hör av sig så snart som möjligt.",
					"message_2": "Vårt team hör av sig så snart som möjligt. Vi har även skickat en bekräftelse till"
				},
				"we_are_sorry": {
					"title": "Beklagar, vi kan dessvärre inte godkänna er ansökan i nuläget.",
					"message_1_unsupported_country": "Klarna stöder för närvarande inte ditt valda land:",
					"message_1_sensitive_goods": "Klarna stödjer för närvarande inte den valda produktkategorin:",
					"message_1_platform": "Klarna stödjer för närvarande inte er valda e-handelsplattform:",
					"message_2": "Vi jobbar kontinuerligt med att skapa nya samarbeten och kommer därmed kontakta er så snart som möjligt om vi kan fortsätta hantera er ansökan. ",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Du kan fortfarande använda"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "från vår partner Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Vilken plattform använder du?",
					"subtitle": "Välj din e-handelplattform så integrerar vi din verksamhet på nolltid.",
					"custom": "Egenbyggd integration",
					"other_platform": "Andra integrationslösningar",
					"platform_search": {
						"label": "E-handelplattform",
						"no_match": "Inga träffar hittades för \"{input}\""
					},
					"buttons": {
						"back": "Tillbaka"
					}
				},
				"partner": {
					"title_line_1": "Vilken betaltjänstpartner skulle du vilja använda?",
					"subtitle": "Välj den betaltjänstpartner som passar dina behov bäst."
				},
				"account_creation_loading": {
					"title": "Skapar ditt konto...",
					"message": "Ställer in ditt företags-ID..."
				},
				"application_checking": {
					"title": "Kontrollerar din ansökan...",
					"message": "Analyserar butiksdata"
				},
				"application_review": {
					"title": "Vi håller på att granska din ansökan.",
					"title_approved": "Din ansökan har godkänts!",
					"message": "Detta är en manuell process. Hur mycket tid som krävs kan variera, men vi kommer att ordna det så snart som möjligt.",
					"email_info_1": "Vi har skickat dig ett e-postmeddelande med ämnesraden \"{subject}\".",
					"email_info_2": "Följ stegen som anges för att logga in och se status för din ansökan.",
					"email_info_2_approved": "Följ stegen som anges för att logga in och integrera Klarna i din webbutik.",
					"email_subject": "Välkommen till Klarnas Butiksportal",
					"resend_email": "Skicka e-post igen"
				},
				"user_already_exists": {
					"title": "Logga in på Butiksportalen för att fortsätta",
					"message_1": "Den här e-postadressen är redan kopplad till ett konto på Butiksportalen. För att ändra ditt nuvarande konto, vänligen logga in",
					"log_in": "Logga in på Butiksportalen ",
					"forgot_password": "Glömt ditt lösenord?"
				},
				"otherPlatform": {
					"info": "Vi har redan en integration för {platform}",
					"link": "Påbörja din integration här",
					"title": "Smoooth – du kan integrera med en gång!",
					"info2": "Goda nyheter! Du kan integrera Klarna med din butik direkt från <strong>{platform}</strong>.",
					"link2": "Gå till {platform} + Klarna-integration"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Vänligen ta kontakt med vår säljavdelning",
							"SE": "Vänligen ta kontakt med vår säljavdelning på"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Erbjuder du någon av följande produkter eller tjänster?",
					"subtitle_2": "Klarna kan definiera några produkter som begränsade beroende på marknad, lagar, försäljningsvolym, riskbenägenhet och andra begränsningar som kan tillåtas och inte får behandlas utan Klarnas godkännande.",
					"titleV2": "Välj det alternativ som passar in på ditt företag nedan.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Ange begränsade produkter",
							"description_2": "Tobak, e-cigaretter, vape, cannabisprodukter, alkohol, vuxet innehåll"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Resor, turnéer och evenemang",
							"description_2": "Transporter, evenemang, biljettplattformar, hotell eller boende, uthyrning, resebyråer"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Licensvapen",
							"description_2": "Ammunition, vapenknivar, jaktutrustning, batonger, pepparspray"
						},
						"MARKETPLACE": {
							"title_2": "Marknadsplats för fildelning",
							"description_2": "Tjänster som ger tredje part möjlighet att sälja sina varor eller erbjuda tjänster via sin onlineplattform"
						},
						"PHARMACEUTICALS": {
							"title_2": "Läkemedel och medicinska tjänster",
							"description_2": "Distribution av receptbelagda läkemedel, medicinsk utrustning inklusive estetiska produkter och tatueringar"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Medlemskap, prenumerationer och tjänster",
							"description_2": "Prenumeration på fysiska varor, digitalt innehåll, streamingtjänster, dejtingsajter m.m."
						},
						"NONE": {
							"title_2": "Jag erbjuder en annan typ av produkt/tjänst"
						}
					},
					"link": "Mer om begränsade varor",
					"buttons": {
						"next": "Nästa",
						"continue": "Fortsätt"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Ange ditt postnummer för att fylla i andra delar av din adress automatiskt",
						"US": "Ange ditt postnummer för att fylla i andra delar av din adress automatiskt"
					},
					"label": {
						"default": "Postnummer",
						"US": "Postnummer"
					},
					"error": {
						"default": "Vänligen ange en giltig postkod",
						"US": "Ange ett giltigt postnummer"
					}
				},
				"city": {
					"label": "Stad",
					"error": "Vänligen ange en stad"
				},
				"street": {
					"label": "Adress",
					"error": "Vänligen ange en adress",
					"tooltip": "Börja skriva för att se fler gatuförslag",
					"no_suggestion_found": "Inga träffar för {input}"
				},
				"country": {
					"label": "Land",
					"error": "Vänligen välj ett land"
				},
				"region": {
					"label": "Region (valfritt)"
				},
				"state": {
					"label": "Stat",
					"error": "Vänligen ange en stat/provins"
				}
			},
			"platforms": {
				"custom": "API-integration",
				"other": "Jag kan inte hitta min plattform"
			},
			"buttons": {
				"back": "Tillbaka"
			},
			"products": {
				"not_available": "Ej tillgänglig på {reason}",
				"not_available_country": "Inte tillgängligt i ditt land",
				"not_available_platform": "Inte tillgängligt på {platform}",
				"why_product": "Varför Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Byt ut din butiks kassa med Klarnas kompletta kassatjänster."
					},
					"description_expanded": {
						"default": "Byt ut din butiks kassa med Klarnas kompletta kassatjänster."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Betala nu"
							},
							"description": {
								"default": "Erbjud direktbetalning med kort eller banköverföring."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Betala sen"
							},
							"description": {
								"default": "Erbjud 30 dagar för betalning. Ingen ränta."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Dela upp"
							},
							"description": {
								"default": "Erbjud delbetalning över 6-36 månader.",
								"DE": "Erbjud delbetalning över 6-24 månader",
								"AT": "Erbjud delbetalning över 6-24 månader."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Avbetalningar"
							},
							"description": {
								"default": "Erbjud 3 räntefria avbetalningar.",
								"GB": "Erbjud 3 räntefria avbetalningar."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Delbetalningar",
								"AU": "4 delbetalningar"
							},
							"description": {
								"default": "Erbjud 4 räntefria avbetalningar.",
								"GB": "Erbjud 4 räntefria avbetalningar."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Andra betalningsalternativ"
							},
							"description": {
								"default": "Kreditkort, betalkort med mera"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Personliga Meddelanden"
							}
						},
						"billing": {
							"name": {
								"default": "Automatisk identifiering och fakturering"
							}
						},
						"shipping": {
							"name": {
								"default": "Personliga fraktalternativ"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Support efter köpet"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Betalningsmetod"
					},
					"description": {
						"default": "Lägg till Klarna betalningsmetoder i din befintliga kassa"
					},
					"description_expanded": {
						"default": "När du erbjuder Klarnas betalningsmetoder får du en genomsnittlig ökning på 30 % i konverteringar, 41 % i genomsnittligt ordervärde och 36 % i köpfrekvens."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Betala nu"
							},
							"description": {
								"default": "Erbjud direktbetalning med kort eller banköverföring."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Betala sen"
							},
							"description": {
								"default": "Kunder betalar 30 dagar efter köpet, utan ränta."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Dela upp"
							},
							"description": {
								"default": "Kunder kan betala på 6–36 månader.",
								"DE": "Kunder kan betala på 6–24 månader",
								"AT": "Kunder kan betala på 6–24 månader."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Avbetalningar"
							},
							"description": {
								"default": "Erbjud 3 räntefria avbetalningar.",
								"GB": "Erbjud 3 räntefria avbetalningar."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 betalningar",
								"CA": "Fyra betalningar",
								"AU": "4 delbetalningar"
							},
							"description": {
								"default": "Erbjud 4 räntefria avbetalningar.",
								"GB": "Erbjud 4 räntefria avbetalningar.",
								"US": "En order på 35–1 000 USD kan delas upp i 4 räntefria betalningar som förfaller varannan vecka.",
								"CA": "Ordrar från 35 $ till 1 000 $ kan delas upp på 4 räntefria betalningar som förfaller varannan vecka."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Betala med kort"
							},
							"description": {
								"default": "Erbjud direktbetalning med kort eller banköverföring."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Hur planerar du att sälja?",
					"options": {
						"IN_STORE": "Fysisk butik",
						"TELESALES": "Telefonförsäljning"
					},
					"description": {
						"IN_STORE": "Försäljningen sker i första hand personligen och kunden får artiklarna direkt",
						"TELESALES": "Försäljning sker främst via telefon genom inkommande kundsamtal. Kunden får inte artiklarna direkt."
					}
				},
				"country": {
					"label": "Land"
				},
				"organization_category": {
					"label": "Typ av juridisk enhet",
					"options": {
						"SOLE_TRADER": "Enskild näringsidkare",
						"PARTNERSHIP": "Partnerskap",
						"UNDEFINED": "ODEFINIERAD",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C-corporation",
						"S_CORP": "S-corporation",
						"TRUST_ESTATE": "Stiftelse/dödsbo",
						"INDIVIDUAL": "Individ",
						"SOLE_PROPRIETORSHIP": "Ensam äganderätt",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "LLC med en medlem",
						"LIMITED_LIABILITY_COMPANY": "LLC (Limited Liability Company)",
						"PUBLIC_LISTED_COMPANY": "Börsnoterat företag",
						"PRIVATE_COMPANY": "PRIVAT_FÖRETAG"
					}
				},
				"store_category": {
					"label": "Största varukategori till försäljning",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor för vuxna",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Fordonsprodukter - Fordonsdelar och tillbehör",
						"BAGS_AND_WALLETS": "Smycken & Accessoarer - Väskor och plånböcker",
						"BODY_AND_HAIR_CARE": "Hälsa & Skönhet - Kropps- och hårvård",
						"BOOK_AND_MAGAZINES": "Underhållning - Böcker och tidningar",
						"CANDY": "Mat & Dryck - Godis",
						"CAR_ELECTRONICS": "Elektronik - Bilelektronik",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Barnprodukter - Barnkläder och vårdprodukter",
						"CHILDREN_TOYS": "Barnprodukter - Barnleksaker",
						"CLEANING_AND_SANITARY": "Hem & Trädgård - Rengörings- och sanitetsprodukter",
						"COLLECTIBLES": "Fritid, Sport & Hobby - Samlarobjekt",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Fritid, Sport & Hobby - Konceptbutiker och diverse",
						"COSMETICS": "Hälsa & Skönhet - Kosmetika",
						"COSTUMES_AND_PARTY_SUPPLIES": "Fritid, Sport & Hobby - Kostymer och festtillbehör",
						"DATING_SERVICES": "Immateriella produkter - Dejtingtjänster",
						"DECORATION_AND_ART": "Hem & Trädgård - Dekoration och konst",
						"DIETARY_SUPPLEMENTS": "Hälsa & Skönhet - Kosttillskott",
						"DIGITAL_SERVICES": "Immateriella produkter - Digitala tjänster",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Barnprodukter - Diversifierade barnprodukter",
						"DIVERSIFIED_ELECTRONICS": "Elektronik - Diversifierad elektronik",
						"DIVERSIFIED_ENTERTAINMENT": "Underhållning - Diversifierad underhållning",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotiskt material - Diversifierad erotik",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Hälsa och skönhet – diversifierade hälso- och skönhetsprodukter",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hem & Trädgård - Diversifierade hem- och trädgårdsprodukter",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Smycken & Accessoarer - Diversifierad smycken och accessoarer",
						"EDUCATION": "Immateriella produkter - Utbildning",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronik - Elektronisk utrustning och relaterade tillbehör",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotiskt material - Erotiska kläder och tillbehör",
						"EVENT_TICKETS": "Immateriella produkter - Eventbiljetter",
						"FOOD_AND_BEVERAGE": "Mat & Dryck - Mat och dryck",
						"FRAGRANCES": "Hälsa & Skönhet - Parfymer",
						"FURNITURE": "Hem & Trädgård - Möbler",
						"GENERAL_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor",
						"HOBBY_ARTICLES": "Fritid, Sport & Hobby - Hobbyartiklar",
						"HOUSEHOLD_ELECTRONICS": "Elektronik - Hushållselektronik",
						"JEWELRY_AND_WATCHES": "Smycken & Accessoarer - Smycken och klockor",
						"KITCHENWARE": "Hem & Trädgård - Köksutrustning",
						"MARKETPLACES": "Immateriella produkter - Marknadsplatser",
						"MUSIC_AND_MOVIES": "Underhållning - Musik och film",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Fritid, Sport & Hobby - Musikinstrument och tillbehör",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Smycken & Accessoarer - Receptfria solglasögon och linser",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronik - Kontorsmaskiner och relaterade tillbehör",
						"OTHER_SERVICES": "Immateriella produkter - Andra tjänster",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Hälsa & Skönhet - Personlig omvårdnad och kroppsförbättring",
						"PET_SUPPLIES": "Hem & Trädgård - Djurtillbehör",
						"PHARMACEUTICAL_PRODUCTS": "Hälsa & Skönhet - Farmaceutiska produkter",
						"PLANTS_AND_FLOWERS": "Hem & Trädgård - Plantor och blommor",
						"PRESCRIPTION_OPTICS": "Hälsa & Skönhet - Receptbelagd optik",
						"PRINTS_AND_PHOTOS": "Fritid, Sport & Hobby - Tryck och foton",
						"SAFETY_PRODUCTS": "Hem & Trädgård - Säkerhetsprodukter",
						"SEX_TOYS": "Erotiskt material - Sexleksaker",
						"SPORTS_GEAR_AND_OUTDOOR": "Fritid, Sport & Hobby - Sport- och fritidsutrustning",
						"TOBACCO": "Mat & Dryck - Tobak",
						"TOOLS_AND_HOME_IMPROVEMENT": "Hem & Trädgård - Verktyg och renovering",
						"TRAVEL_SERVICES": "Immateriella produkter - Resetjänster",
						"UNDERWEAR": "Kläder & Skor - Underkläder",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Underhållning - TV-spel och relaterade tillbehör",
						"WHEELS_AND_TIRES": "Fordonsprodukter - Hjul och däck",
						"WINE_BEER_AND_LIQUOR": "Mat & Dryck - Vin, öl och sprit",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Kläder & Skor - Kläder och skor för unga"
					}
				},
				"currency": {
					"label": "Valuta"
				},
				"account_type": {
					"label": "Bankkontotyp",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Lokalt i Sverige",
						"LOCAL_US": "Lokalt i USA",
						"LOCAL_GENERIC": "Lokalt i Norge/Danmark",
						"SPECIAL": "Special",
						"BANKGIRO": "Lokalt i Sverige, bankgiro",
						"PLUSGIRO": "Lokalt i Sverige, plusgiro"
					}
				},
				"person_role": {
					"label": "Roll",
					"options": {
						"LEGAL_REPRESENTATIVE": "Firmatecknare",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternativ huvudman",
						"ULTIMATE_BENEFICIAL_OWNER": "Verklig huvudman",
						"OWNER": "Ägare"
					}
				},
				"business_size": {
					"label": "Företagets storlek",
					"options": {
						"LARGE": "stor",
						"MEDIUM": "medium",
						"small": "liten"
					}
				},
				"sensitive_good_category": {
					"label": "Erbjuder du någon av följande produkter eller tjänster i din fysiska butik?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Produkter med åldersgräns",
						"LICENSED_WEAPONS": "Licensvapen",
						"PHARMA_AND_MEDICAL_SERVICES": "Läkemedel och medicinska tjänster",
						"TRAVEL_TOURS_EVENTS": "Resor och evenemang",
						"PEER_TO_PEER_MARKETPLACE": "Marknadsplats för försäljning mellan konsumenter",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Medlemskap, prenumerationer och tjänster",
						"NONE": "Jag erbjuder en annan typ av produkt/tjänst"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tobak, e-cigaretter, vape, cannabisprodukter, alkohol, vuxet innehåll",
						"LICENSED_WEAPONS": "Ammunition, vapenknivar, jaktutrustning, batonger, pepparspray",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribution av receptbelagda läkemedel, medicinsk utrustning inklusive estetiska produkter och tatueringar",
						"TRAVEL_TOURS_EVENTS": "Transporter, evenemang, biljettplattformar, hotell eller boende, uthyrning, resebyråer",
						"PEER_TO_PEER_MARKETPLACE": "Tjänster som ger tredje part möjlighet att sälja sina varor eller erbjuda tjänster via sin onlineplattform",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Prenumeration på fysiska varor, digitalt innehåll, streamingtjänster, dejtingsajter m.m.",
						"NONE": "Jag erbjuder en annan typ av produkt/tjänst"
					},
					"error_message": "Vi beklagar. Vi kan inte gå vidare med din ansökan då vi för närvarande inte stödjer den typen av produkter eller tjänster som du valt."
				}
			},
			"common": {
				"country": {
					"label": "Land"
				},
				"address": {
					"city": {
						"label": "Stad"
					},
					"postal_code": {
						"label": "Postnummer"
					},
					"region": {
						"label": "Region"
					},
					"street_address": {
						"label": "Adress till fysisk butik"
					},
					"street_address2": {
						"label": "Adressrad två"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Företagsnamn"
					},
					"registration_authority": {
						"label": "Registreringsmyndighet"
					},
					"registration_id": {
						"label": "Registreringsnummer"
					},
					"subject_to_vat": {
						"label": "Är ditt företag momsregistrerat?"
					},
					"vat_id": {
						"label": "Momsregistreringsnummer"
					},
					"persons": {
						"date_of_birth": {
							"label": "Födelsedatum"
						},
						"first_name": {
							"label": "Förnamn"
						},
						"last_name": {
							"label": "Efternamn"
						},
						"person_identity_document": {
							"label": "Identitetsdokument"
						},
						"person_proof_of_address": {
							"label": "Adressbevis"
						},
						"personal_identifier": {
							"label": "Personligt ID"
						}
					},
					"should_auto_capture_orders": {
						"label": "Vill du automatiskt aktivera beställningar?",
						"tooltip": "Ordrar ska aktiveras när varorna överlämnas i butik eller när de skickas från ett lager. Genom att välja \"aktivera automatiskt\" kommer ordern att aktiveras automatiskt när kunden bekräftar köpet."
					}
				},
				"contract_entity": {
					"label": "Kontraktsenhet"
				},
				"contract_onboarding_type": {
					"label": "Typ av onboarding av affärspartner"
				},
				"underwriting_inquiry_email": {
					"label": "E-post för underwriting"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Kontoinnehavare"
					},
					"account_number": {
						"label": "Kontonummer"
					},
					"bic": {
						"label": "BIC-kod"
					},
					"iban": {
						"label": "Kontonummer (IBAN)"
					},
					"is_default": {
						"label": "Använd detta konto för ospecificerade valutor"
					},
					"routing_number": {
						"label": "Clearingnummer"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "E-post för kontakt"
					},
					"name": {
						"label": "Butiksnamn"
					},
					"support_email": {
						"label": "E-postadress till kundtjänst"
					},
					"support_phone": {
						"label": "Supporttelefonnummer"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Traditionell försäljning av varor",
							"VOUCHER": "Kupong",
							"MEMBERSHIP": "Medlemskap",
							"SUBSCRIPTION": "Abonnemang",
							"PHARMACIES": "Apotek",
							"US_PHARMACIES": "Amerikanska apotek",
							"MEDICAL_SERVICES": "Medicinska tjänster",
							"MARKETPLACES": "Marknadsplatser",
							"FIREARM_DEALERS": "Vapenhandlare",
							"AUCTIONS": "Auktioner",
							"ALCOHOL": "Alkohol",
							"TOBACCO": "Tobak",
							"HEMP_CBD_THC": "Hampa, CBD eller THC",
							"DONATIONS_CHARITY": "Donationer och välgörenhet",
							"TRAVEL": "Resor",
							"EVENTS": "Evenemang",
							"COURSES": "Kurser",
							"EDUCATIONAL_COURSES": "",
							"FOOD_DELIVERY": "",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "",
							"DIGITAL_CONTENT": "",
							"GAMING_INDUSTRY": ""
						}
					}
				},
				"terms_and_conditions": {
					"default": "Användarvillkor",
					"UPSELL_WEBSTORE_TO_KPOS": "Villkor för Klarna In-store"
				},
				"pricing_terms": {
					"default": "Villkor för prissättning",
					"UPSELL_WEBSTORE_TO_KPOS": "Prissättning för Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Ytterligare information",
				"bank_account": "Vad är dina bankkontouppgifter?",
				"business_size": "Vad är din förväntade årliga volym genom Klarna Point of Sale?",
				"in_store_get_started": "Kom igång med ditt företag med Klarna.",
				"in_store_legal_form": "Vilket typ av företag har du?",
				"in_store_registered_address": "Vad är din folkbokförda adress?",
				"in_store_registration": "Är din verksamhet ett registrerat företag?",
				"in_store_stakeholder": "Vem leder företaget?",
				"in_store_stores": "Vilka är dina butiksuppgifter för Klarna Point of Sale?",
				"in_store_vat": "Är ditt företag momsregistrerat?",
				"product_channel": "Hur planerar ditt företag att använda Klarna Point of Sale?",
				"sensitive_goods": "Vilken kategori av produkter kommer du att sälja med Klarna Point of Sale.",
				"ads_manager_get_started": "Nästan där.",
				"content_store_get_started": "Nästan där."
			},
			"subtitle": {
				"additional_data": "Vi granskar din ansökan och behöver lite mer information för att gå vidare.",
				"bank_account": "Klarnatransaktioner kommer att föras över till det här konto.",
				"business_size": "Vi behöver viss grundläggande företagsinformation för att kunna hantera din ansökan.",
				"in_store_get_started": "Vi behöver lite grundläggande information för att ta dig till rätt plats",
				"in_store_legal_form": "Vi är skyldiga att ställa vissa frågor baserat på din företagstyp.",
				"in_store_registered_address": "Det är här ditt företag är lagligt registrerat och kommer att synas på dina klarnas kundfakturor.",
				"in_store_registration": "Vi behöver ditt företagsregistreringsnummer för att verifiera dina företagsuppgifter.",
				"in_store_stakeholder": "Som finansinstitut är vi skyldiga att samla in denna information",
				"in_store_stores": "Vi använder informationen för att konfigurera ditt nya Klarna Point of Sale-konto.",
				"in_store_vat": "Det är enklare för oss att verifiera dina företagsuppgifter om du har ett momsregistreringsnummer.",
				"product_channel": "Välj din primära försäljningskanal. Du kommer att kunna använda Klarna Point of Sale för båda kanalerna.",
				"sensitive_goods": "Självbetjäning för Klarna Point of Sale tillåter inte att du säljer varor som belagts med restriktioner av Klarna. ",
				"ads_manager_get_started": "Ange en faktureringsadress som kampanjfakturor kan skickas till. Du måste vara administratöranvändare för att aktivera kontot. Admin kan sedan ge andra användare tillstånd.",
				"content_store_get_started": "Innan du får åtkomst till innehållshanteraren, läs och godkänn våra villkor."
			},
			"summary": {
				"title": "Granska dina uppgifter innan du skickar in din ansökan"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Vi behandlar din ansökan. Det kan ta en stund.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vänta…",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vänta…"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Din ansökan behandlas och vi skapar ditt nya handlar-ID."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Vi färdigställer allt för ditt Ads Manager-konto."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Vi förbereder allt för ditt konto på Innehållsplaneraren."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Grattis! Din ansökan har godkänts.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Allt är klart!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Allt är klart!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Låt oss nu integrera Klarna i din webbutik. Gå till fliken Produkter i ditt säljarportalkonto för att hitta dina integrationsuppgifter och instruktioner om hur du använder dem."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Nu kan vi aktivera din butik så att du kan börja ta emot betalningar direkt."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Gå till annonshanteraren för att börja skapa din första kampanj."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Gå över till innehållshanteraren och publicera din första affär idag."
							}
						]
					},
					"second_title": {
						"default": "Besök Klarna docs för mer information om hur du integrerar med Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Behöver du hjälp med att aktivera din butik? Vi finns här för att hjälpa dig",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Behöver du hjälp att använda annonshanteraren? Kolla våra vanliga frågor eller hör av dig till vår affärssupport så hjälper vi dig gärna.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Behöver du hjälp att använda innehållshanteraren? Kolla våra vanliga frågor eller hör av dig till vår affärssupport så hjälper vi dig gärna."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Våra riktlinjer för bästa praxis kan hjälpa dig att få ut det mesta av ditt nya partnerskap med oss."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Kontakta butikssupport, så hjälper vi dig gärna."
							},
							{
								"text": "Kontakta support",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Besök Vanliga frågor",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Besök Vanliga frågor",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Då kör vi",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Kom igång",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Kom igång",
						"UPSELL_WEBSTORE_TO_KPOS": "Börja sälja"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Tack! Vi granskar din ansökan.",
					"badge": "Ca 5-7 dagar",
					"paragraphs": [
						{
							"text": "Du kommer att få ett e-postmeddelande när granskningen är klar eller om vi behöver ytterligare information."
						}
					],
					"second_title": "Under tiden kolla din e-post",
					"second_paragraphs": [
						{
							"text": "Vi har skickat ett e-postmeddelande till dig med ämneslänken ”Välkommen till Klarnas handelsportal”. Följ stegen där för att logga in och aktivera ditt konto."
						}
					]
				},
				"SUSPENDED": {
					"title": "Tyvärr godkändes inte din ansökan.",
					"paragraphs": [
						{
							"text": "Efter att ha granskat dina företagsuppgifter kan vi inte gå vidare med din ansökan för <strong>{businessName}</strong>."
						},
						{
							"text": "Det här är några av de vanligaste orsakerna:"
						},
						{
							"list": [
								{
									"text": "Din butik följer inte Klarnas etiska riktlinjer."
								},
								{
									"text": "Din kundtjänst är otillgänglig."
								},
								{
									"text": "Andra administrativa faktorer."
								}
							]
						},
						{
							"text": "Tack för ditt intresse av <strong>Klarna [In-store]</strong> vi hoppas att vi kan jobba ihop i framtiden."
						}
					],
					"second_title": "Om du har ytterligare frågor",
					"second_paragraphs": [
						{
							"text": "Angående vårt beslut eller någon annan Klarna-produkt vänligen kontakta oss, vi hjälper dig gärna."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Vem skriver på kontrakt för ditt företag?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Ditt företag är på väg att sluta ett avtal med Klarna. Vi behöver verifiera vem som är juridiskt auktoriserad att underteckna kontrakt."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Finns det någon som äger mer än 25 % av företaget?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"default": [
							{
								"text": "Vi behöver veta alla personer som äger mer än 25 % av aktierna eller rösträtten i företaget eller som utövar liknande kontroll. Vi är juridiskt skyldiga att samla in denna information enligt EU:s penningtvättsdirektiv ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Vem leder företaget?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi är juridiskt skyldiga enligt EU:s lagstiftning om penningtvätt ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						],
						"US": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"CA": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Finns det någon som äger mer än 25 % av företaget?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Vi är som finansiell institution juridiskt skyldiga att samla in den här information."
							}
						],
						"default": [
							{
								"text": "Vi behöver veta alla personer som äger mer än 25 % av aktierna eller rösträtten i företaget eller som utövar liknande kontroll. Vi är juridiskt skyldiga att samla in denna information enligt EU:s penningtvättsdirektiv ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") att samla in denna information."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Lösningar",
					"title_2": "Betalmetoder",
					"note": "Alla angivna priser är per transaktion",
					"per_transaction": "per transaktion",
					"cross_border_notice": "Extra avgifter kan tillkomma vid överföring mellan länder",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "se",
						"link_text": "prisbilaga"
					},
					"not_available_for_business": "Inte tillgängligt för ditt företag",
					"not_available_for_country": "Du kan endast sälja till andra marknader",
					"not_compatible_with_platform": "Denna tjänst är inte tillgänglig på vald plattform",
					"installed": "Installerad"
				},
				"buttons": {
					"next": "Nästa"
				}
			}
		}
	}
};